{
 "_source": "Have I Been Pwned — https://haveibeenpwned.com",
 "_licence": "CC BY 4.0 — https://creativecommons.org/licenses/by/4.0/",
 "_genereLe": "2026-10-14",
 "_lisezMoi": "Fichier produit par tools/import-fuites.js. Ne pas modifier à la main.",
 "domaines": {
  "000webhost.com": {
   "nom": "000webhost",
   "date": "2015-03-01",
   "comptes": 14936670,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe"
   ]
  },
  "123rf.com": {
   "nom": "123RF",
   "date": "2020-03-22",
   "comptes": 8661578,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "17app.co": {
   "nom": "17",
   "date": "2016-04-19",
   "comptes": 4009640,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "1win.com": {
   "nom": "1win",
   "date": "2024-11-02",
   "comptes": 96166543,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "localisations",
    "adresses IP",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "2fast4u.be": {
   "nom": "2fast4u",
   "date": "2017-12-20",
   "comptes": 17706,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "500px.com": {
   "nom": "500px",
   "date": "2018-07-05",
   "comptes": 14867999,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "7-eleven.com": {
   "nom": "7-Eleven",
   "date": "2026-04-08",
   "comptes": 185256,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "8fit.com": {
   "nom": "8fit",
   "date": "2018-07-01",
   "comptes": 15025407,
   "donnees": [
    "adresses email",
    "genres",
    "localisations",
    "adresses IP",
    "noms",
    "mots de passe"
   ]
  },
  "8tracks.com": {
   "nom": "8tracks",
   "date": "2017-06-27",
   "comptes": 17979961,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "9lives.be": {
   "nom": "9Lives",
   "date": "2014-10-01",
   "comptes": 109515,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "abandonia.com": {
   "nom": "Abandonia (2022)",
   "date": "2022-11-15",
   "comptes": 919790,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "abrigo.com": {
   "nom": "Abrigo",
   "date": "2026-04-14",
   "comptes": 711099,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "abusewith.us": {
   "nom": "AbuseWith.Us",
   "date": "2016-07-01",
   "comptes": 1372550,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "acne.org": {
   "nom": "Acne.org",
   "date": "2014-11-25",
   "comptes": 432943,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "activision.com": {
   "nom": "Activision",
   "date": "2022-12-04",
   "comptes": 16006,
   "donnees": [
    "adresses email",
    "localisations",
    "noms",
    "numéros de téléphone"
   ]
  },
  "adapt.io": {
   "nom": "Adapt",
   "date": "2018-11-05",
   "comptes": 9363740,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "adda.io": {
   "nom": "ADDA",
   "date": "2025-03-24",
   "comptes": 1829314,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "addi.com": {
   "nom": "Addi",
   "date": "2026-03-25",
   "comptes": 34532941,
   "donnees": [
    "adresses email",
    "pièces d'identité",
    "adresses IP",
    "noms",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "adecco.com": {
   "nom": "Adecco",
   "date": "2021-01-03",
   "comptes": 4284538,
   "donnees": [
    "adresses email",
    "genres",
    "localisations",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "abfrl.com": {
   "nom": "Aditya Birla Fashion and Retail",
   "date": "2021-12-01",
   "comptes": 5470063,
   "donnees": [
    "adresses email",
    "genres",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "adobe.com": {
   "nom": "Adobe",
   "date": "2013-10-04",
   "comptes": 152445165,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "adoptmetradingvalues.com": {
   "nom": "Adopt Me Trading Values",
   "date": "2022-07-01",
   "comptes": 86136,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "adpost.com": {
   "nom": "Adpost",
   "date": "2025-02-14",
   "comptes": 3339512,
   "donnees": [
    "adresses email",
    "noms",
    "noms d'utilisateur"
   ]
  },
  "adt.com": {
   "nom": "ADT",
   "date": "2026-04-20",
   "comptes": 5488888,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "adultfriendfinder.com": {
   "nom": "Adult FriendFinder (2016)",
   "date": "2016-10-16",
   "comptes": 169746810,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "adult-fanfiction.org": {
   "nom": "Adult-FanFiction.Org",
   "date": "2018-05-30",
   "comptes": 186082,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "mots de passe"
   ]
  },
  "advanceautoparts.com": {
   "nom": "Advance Auto Parts",
   "date": "2024-06-05",
   "comptes": 79243727,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "aerserv.com": {
   "nom": "AerServ",
   "date": "2018-04-01",
   "comptes": 66308,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "agusiq-torrents.pl": {
   "nom": "AgusiQ-Torrents.pl",
   "date": "2019-09-24",
   "comptes": 90478,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "ahashare.com": {
   "nom": "AhaShare.com",
   "date": "2013-05-30",
   "comptes": 180468,
   "donnees": [
    "adresses email",
    "genres",
    "localisations",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "aitype.com": {
   "nom": "ai.type",
   "date": "2017-12-05",
   "comptes": 20580060,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "adresses IP",
    "noms",
    "numéros de téléphone"
   ]
  },
  "aimware.net": {
   "nom": "Aimware",
   "date": "2019-04-28",
   "comptes": 305470,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "messages privés",
    "noms d'utilisateur"
   ]
  },
  "ajarn.com": {
   "nom": "Ajarn",
   "date": "2018-12-13",
   "comptes": 266399,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "akparti.org.tr": {
   "nom": "AKP Emails",
   "date": "2016-07-19",
   "comptes": 917461,
   "donnees": [
    "adresses email"
   ]
  },
  "alcon.com": {
   "nom": "Alcon",
   "date": "2026-08-01",
   "comptes": 218395,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "allianzlife.com": {
   "nom": "Allianz Life",
   "date": "2025-07-16",
   "comptes": 1115061,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "traceup.com": {
   "nom": "AlpineReplay",
   "date": "2019-08-27",
   "comptes": 898681,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "altenens.is": {
   "nom": "Altenen",
   "date": "2022-06-24",
   "comptes": 1267701,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "aman.com": {
   "nom": "Aman",
   "date": "2026-04-20",
   "comptes": 215563,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "amartfurniture.com.au": {
   "nom": "Amart Furniture",
   "date": "2022-05-16",
   "comptes": 108940,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "americantower.com": {
   "nom": "American Tower",
   "date": "2026-06-12",
   "comptes": 216601,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "ameriprise.com": {
   "nom": "Ameriprise",
   "date": "2026-03-02",
   "comptes": 502597,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "amtrak.com": {
   "nom": "Amtrak",
   "date": "2026-04-03",
   "comptes": 2147679,
   "donnees": [
    "adresses email",
    "noms",
    "adresses postales"
   ]
  },
  "ancestry.com": {
   "nom": "Ancestry",
   "date": "2015-11-07",
   "comptes": 297806,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "androidforums.com": {
   "nom": "Android Forums",
   "date": "2011-10-30",
   "comptes": 745355,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe"
   ]
  },
  "androidlista.com": {
   "nom": "AndroidLista",
   "date": "2021-07-28",
   "comptes": 6640643,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "angelone.in": {
   "nom": "Angel One",
   "date": "2023-04-01",
   "comptes": 6765054,
   "donnees": [
    "comptes bancaires",
    "dates de naissance",
    "adresses email",
    "pièces d'identité",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "animaljam.com": {
   "nom": "Animal Jam",
   "date": "2020-10-12",
   "comptes": 7104998,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "adresses IP",
    "noms",
    "mots de passe",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "animegame.me": {
   "nom": "AnimeGame",
   "date": "2020-02-27",
   "comptes": 1431378,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "animeify.net": {
   "nom": "Animeify",
   "date": "2021-10-14",
   "comptes": 808034,
   "donnees": [
    "adresses email",
    "genres",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "animeleague.net": {
   "nom": "AnimeLeague",
   "date": "2024-07-04",
   "comptes": 192134,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "numéros de téléphone",
    "messages privés",
    "achats",
    "noms d'utilisateur"
   ]
  },
  "anime-planet.com": {
   "nom": "Anime-Planet",
   "date": "2016-01-01",
   "comptes": 368507,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "animoto.com": {
   "nom": "Animoto",
   "date": "2018-07-10",
   "comptes": 22437749,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "localisations",
    "noms",
    "mots de passe"
   ]
  },
  "apk.tw": {
   "nom": "APK.TW",
   "date": "2022-09-03",
   "comptes": 2451197,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "apoia.se": {
   "nom": "APOIA.se",
   "date": "2025-12-16",
   "comptes": 450764,
   "donnees": [
    "adresses email",
    "noms",
    "adresses postales"
   ]
  },
  "apollo.io": {
   "nom": "Apollo",
   "date": "2018-07-23",
   "comptes": 125929660,
   "donnees": [
    "adresses email",
    "localisations",
    "noms",
    "numéros de téléphone"
   ]
  },
  "appartoo.com": {
   "nom": "Appartoo",
   "date": "2017-03-25",
   "comptes": 49681,
   "donnees": [
    "jetons d'accès",
    "adresses email",
    "genres",
    "adresses IP",
    "noms",
    "mots de passe",
    "adresses postales",
    "messages privés"
   ]
  },
  "appen.com": {
   "nom": "Appen",
   "date": "2020-06-22",
   "comptes": 5888405,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "aptoide.com": {
   "nom": "Aptoide",
   "date": "2020-04-13",
   "comptes": 20012235,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe"
   ]
  },
  "armorgames.com": {
   "nom": "Armor Games",
   "date": "2019-01-01",
   "comptes": 10604307,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "armyforceonline.com": {
   "nom": "Army Force Online",
   "date": "2016-05-18",
   "comptes": 1531235,
   "donnees": [
    "adresses email",
    "localisations",
    "adresses IP",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "artistsnclients.com": {
   "nom": "Artists&Clients",
   "date": "2025-08-31",
   "comptes": 95351,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "artsy.net": {
   "nom": "Artsy",
   "date": "2018-04-01",
   "comptes": 1079970,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe"
   ]
  },
  "artvalue.com": {
   "nom": "Artvalue.com",
   "date": "2019-06-19",
   "comptes": 157692,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "ashleymadison.com": {
   "nom": "Ashley Madison",
   "date": "2015-07-19",
   "comptes": 30811934,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "questions secrètes",
    "noms d'utilisateur"
   ]
  },
  "anps.fr": {
   "nom": "Association Nationale des Premiers Secours",
   "date": "2026-01-30",
   "comptes": 5600,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms"
   ]
  },
  "astropid.com": {
   "nom": "Astropid",
   "date": "2013-12-19",
   "comptes": 5788,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "messages privés",
    "noms d'utilisateur"
   ]
  },
  "aternos.org": {
   "nom": "Aternos",
   "date": "2015-12-06",
   "comptes": 1436486,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "atlasmenu.net": {
   "nom": "Atlas Menu",
   "date": "2026-05-30",
   "comptes": 63926,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "atlasquantum.com": {
   "nom": "Atlas Quantum",
   "date": "2018-08-25",
   "comptes": 261463,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone"
   ]
  },
  "atmeltomo.com": {
   "nom": "Atmeltomo",
   "date": "2021-04-16",
   "comptes": 580177,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "audiusa.com": {
   "nom": "Audi",
   "date": "2019-08-14",
   "comptes": 2743539,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "aura.com": {
   "nom": "Aura",
   "date": "2026-03-06",
   "comptes": 903080,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "autocentrum.pl": {
   "nom": "Autocentrum.pl",
   "date": "2018-02-04",
   "comptes": 143717,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "autosur.fr": {
   "nom": "AUTOSUR",
   "date": "2025-03-16",
   "comptes": 487226,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "autotrader.com": {
   "nom": "Autotrader",
   "date": "2023-01-06",
   "comptes": 20032,
   "donnees": [
    "adresses email",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "avast.com": {
   "nom": "Avast",
   "date": "2014-05-26",
   "comptes": 422959,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "avito.ma": {
   "nom": "Avito",
   "date": "2022-11-18",
   "comptes": 2721835,
   "donnees": [
    "adresses email",
    "localisations",
    "adresses IP",
    "noms",
    "numéros de téléphone"
   ]
  },
  "avvo.com": {
   "nom": "Avvo",
   "date": "2019-12-17",
   "comptes": 4101101,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "babynames.com": {
   "nom": "Baby Names",
   "date": "2008-10-24",
   "comptes": 846742,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "bakerdist.com": {
   "nom": "Baker Distributing",
   "date": "2026-05-23",
   "comptes": 102935,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "bannerbit.com": {
   "nom": "BannerBit",
   "date": "2018-12-29",
   "comptes": 213415,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "banorte.com": {
   "nom": "Banorte",
   "date": "2014-08-18",
   "comptes": 2107000,
   "donnees": [
    "adresses email",
    "genres",
    "pièces d'identité",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "battlefieldheroes.com": {
   "nom": "Battlefield Heroes",
   "date": "2011-06-26",
   "comptes": 530270,
   "donnees": [
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "battlefy.com": {
   "nom": "Battlefy",
   "date": "2016-01-11",
   "comptes": 83610,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "baydoner.com": {
   "nom": "Baydöner",
   "date": "2026-03-08",
   "comptes": 1266822,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "pièces d'identité",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "achats"
   ]
  },
  "bcdtravel.com": {
   "nom": "BCD Travel",
   "date": "2026-05-29",
   "comptes": 396313,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "beautifulpeople.com": {
   "nom": "Beautiful People",
   "date": "2015-11-11",
   "comptes": 1100089,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "adresses IP",
    "noms",
    "mots de passe"
   ]
  },
  "beckett.com": {
   "nom": "Beckett Collectibles",
   "date": "2025-11-09",
   "comptes": 1041238,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "bell.ca": {
   "nom": "Bell (2017 breach)",
   "date": "2017-05-15",
   "comptes": 2231256,
   "donnees": [
    "adresses email",
    "localisations",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "noms d'utilisateur"
   ]
  },
  "benchmark.rs": {
   "nom": "Benchmark",
   "date": "2019-11-01",
   "comptes": 93343,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "berkadia.com": {
   "nom": "Berkadia",
   "date": "2026-03-19",
   "comptes": 305216,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "bestialitysextaboo.com": {
   "nom": "Bestialitysextaboo",
   "date": "2018-03-19",
   "comptes": 3204,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "adresses IP",
    "mots de passe",
    "messages privés",
    "noms d'utilisateur"
   ]
  },
  "betterment.com": {
   "nom": "Betterment",
   "date": "2026-01-09",
   "comptes": 1435174,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "localisations",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "bhinneka.com": {
   "nom": "Bhinneka",
   "date": "2020-01-27",
   "comptes": 1274340,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "bigbasket.com": {
   "nom": "bigbasket",
   "date": "2020-10-14",
   "comptes": 24500011,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "bigmoneyjobs.com": {
   "nom": "BigMoneyJobs",
   "date": "2014-04-03",
   "comptes": 36789,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "binweevils.com": {
   "nom": "Bin Weevils",
   "date": "2014-09-01",
   "comptes": 1287073,
   "donnees": [
    "adresses email",
    "genres",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "biohack.me": {
   "nom": "Biohack.me",
   "date": "2016-12-02",
   "comptes": 3402,
   "donnees": [
    "adresses email",
    "mots de passe",
    "messages privés",
    "noms d'utilisateur"
   ]
  },
  "forum.btcsec.com": {
   "nom": "Yandex Dump",
   "date": "2014-09-07",
   "comptes": 1186564,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "bitcointalk.org": {
   "nom": "Bitcoin Talk",
   "date": "2015-05-22",
   "comptes": 501407,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "adresses IP",
    "mots de passe",
    "questions secrètes",
    "noms d'utilisateur"
   ]
  },
  "bitly.com": {
   "nom": "Bitly",
   "date": "2014-05-08",
   "comptes": 9313136,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "bittorrent.com": {
   "nom": "BitTorrent",
   "date": "2016-01-01",
   "comptes": 34235,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "bitview.net": {
   "nom": "BitView",
   "date": "2024-12-14",
   "comptes": 63127,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "adresses IP",
    "mots de passe",
    "messages privés",
    "noms d'utilisateur"
   ]
  },
  "blackhatworld.com": {
   "nom": "Black Hat World",
   "date": "2014-06-23",
   "comptes": 777387,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "blackberryfans.org": {
   "nom": "BlackBerry Fans",
   "date": "2022-05-06",
   "comptes": 174168,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "blackspigot.com": {
   "nom": "BlackSpigotMC",
   "date": "2019-07-14",
   "comptes": 140029,
   "donnees": [
    "adresses email",
    "genres",
    "localisations",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "blankmediagames.com": {
   "nom": "BlankMediaGames",
   "date": "2018-12-28",
   "comptes": 7633234,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "achats",
    "noms d'utilisateur"
   ]
  },
  "bleachanime.org": {
   "nom": "Bleach Anime Forum",
   "date": "2015-01-01",
   "comptes": 143711,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "bloomstoday.com": {
   "nom": "Blooms Today",
   "date": "2023-11-11",
   "comptes": 3184010,
   "donnees": [
    "adresses email",
    "noms",
    "données de carte bancaire",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "boat-lifestyle.com": {
   "nom": "boAt",
   "date": "2024-03-25",
   "comptes": 7528985,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "bolt.cd": {
   "nom": "Bolt",
   "date": "2017-03-01",
   "comptes": 995274,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "bombuj.eu": {
   "nom": "Bombuj.eu",
   "date": "2018-12-07",
   "comptes": 575437,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "bonobos.com": {
   "nom": "Bonobos",
   "date": "2020-08-14",
   "comptes": 2811929,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "données de carte bancaire",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "bookchor.com": {
   "nom": "Bookchor",
   "date": "2021-01-28",
   "comptes": 498297,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "bookcrossing.com": {
   "nom": "BookCrossing",
   "date": "2012-11-05",
   "comptes": 1582323,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "localisations",
    "adresses IP",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "bookmate.com": {
   "nom": "Bookmate",
   "date": "2018-07-08",
   "comptes": 3830916,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "botoflegends.com": {
   "nom": "Bot of Legends",
   "date": "2014-11-13",
   "comptes": 238373,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "boulanger.com": {
   "nom": "Boulanger",
   "date": "2024-09-06",
   "comptes": 2077078,
   "donnees": [
    "adresses email",
    "localisations",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "bourse-des-vols.com": {
   "nom": "Bourse des Vols",
   "date": "2021-01-12",
   "comptes": 1460130,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "noms",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "bouyguestelecom.fr": {
   "nom": "Bouygues Telecom",
   "date": "2025-08-04",
   "comptes": 5685771,
   "donnees": [
    "comptes bancaires",
    "dates de naissance",
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "forums.boxee.com": {
   "nom": "Boxee",
   "date": "2014-03-29",
   "comptes": 158093,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "localisations",
    "adresses IP",
    "mots de passe",
    "messages privés",
    "noms d'utilisateur"
   ]
  },
  "brandnewtube.com": {
   "nom": "Brand New Tube",
   "date": "2022-08-14",
   "comptes": 349627,
   "donnees": [
    "adresses email",
    "genres",
    "adresses IP",
    "mots de passe",
    "messages privés",
    "noms d'utilisateur"
   ]
  },
  "brazzers.com": {
   "nom": "Brazzers",
   "date": "2013-04-01",
   "comptes": 790724,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "breached.vc": {
   "nom": "BreachForums",
   "date": "2022-11-29",
   "comptes": 212156,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "messages privés",
    "noms d'utilisateur"
   ]
  },
  "breachforums.hn": {
   "nom": "BreachForums (2025)",
   "date": "2025-08-11",
   "comptes": 672247,
   "donnees": [
    "adresses email",
    "mots de passe",
    "messages privés",
    "noms d'utilisateur"
   ]
  },
  "breachforums.vc": {
   "nom": "BreachForums Clone",
   "date": "2023-06-17",
   "comptes": 4204,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "breachforums.bf": {
   "nom": "BreachForums Version 5",
   "date": "2026-03-26",
   "comptes": 339778,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "brinkshome.com": {
   "nom": "Brinks Home",
   "date": "2026-07-13",
   "comptes": 732162,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "données de carte bancaire",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "btc-alpha.com": {
   "nom": "BTC-Alpha",
   "date": "2021-11-02",
   "comptes": 362426,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "btc-e.com": {
   "nom": "BTC-E",
   "date": "2014-10-01",
   "comptes": 568340,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "btobet.com": {
   "nom": "BtoBet",
   "date": "2019-12-26",
   "comptes": 444241,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "localisations",
    "adresses IP",
    "noms",
    "noms d'utilisateur"
   ]
  },
  "budtrader.com": {
   "nom": "BudTrader",
   "date": "2024-06-27",
   "comptes": 2721185,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "bukalapak.com": {
   "nom": "Bukalapak",
   "date": "2017-10-23",
   "comptes": 13369666,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "nap.bg": {
   "nom": "Bulgarian National Revenue Agency",
   "date": "2019-07-15",
   "comptes": 471167,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "burgerkingrus.ru": {
   "nom": "Burger King Russia",
   "date": "2024-08-25",
   "comptes": 3155792,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "noms",
    "numéros de téléphone"
   ]
  },
  "businessacumen.biz": {
   "nom": "Business Acumen Magazine",
   "date": "2014-04-25",
   "comptes": 26596,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "cafemom.com": {
   "nom": "CafeMom",
   "date": "2014-04-10",
   "comptes": 2628148,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "cafepress.com": {
   "nom": "CafePress",
   "date": "2019-02-20",
   "comptes": 23205290,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "canadagoose.com": {
   "nom": "Canada Goose",
   "date": "2025-07-04",
   "comptes": 581877,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "données de carte bancaire",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "canadalife.com": {
   "nom": "Canada Life",
   "date": "2026-04-20",
   "comptes": 237810,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "canadiantire.ca": {
   "nom": "Canadian Tire",
   "date": "2025-10-02",
   "comptes": 38306562,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "données de carte bancaire",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "cannabis.com": {
   "nom": "Cannabis.com",
   "date": "2014-02-05",
   "comptes": 227746,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "localisations",
    "adresses IP",
    "mots de passe",
    "messages privés",
    "noms d'utilisateur"
   ]
  },
  "canva.com": {
   "nom": "Canva",
   "date": "2019-05-24",
   "comptes": 137272116,
   "donnees": [
    "adresses email",
    "localisations",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "capitaleconomics.com": {
   "nom": "Capital Economics",
   "date": "2020-12-12",
   "comptes": 263829,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "cardmafia.cc": {
   "nom": "Carding Mafia (December 2021)",
   "date": "2021-12-28",
   "comptes": 303877,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "cargurus.com": {
   "nom": "CarGurus",
   "date": "2026-02-14",
   "comptes": 12461887,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "carhartt.com": {
   "nom": "Carhartt",
   "date": "2026-08-13",
   "comptes": 12933413,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "carmax.com": {
   "nom": "CarMax",
   "date": "2026-01-24",
   "comptes": 431371,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "carnivalcorp.com": {
   "nom": "Carnival",
   "date": "2026-04-18",
   "comptes": 7531359,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "noms"
   ]
  },
  "cashcrate.com": {
   "nom": "CashCrate",
   "date": "2016-11-17",
   "comptes": 6844490,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "adresses postales"
   ]
  },
  "catho.com.br": {
   "nom": "Catho",
   "date": "2020-03-01",
   "comptes": 1173012,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "catwatchful.com": {
   "nom": "Catwatchful",
   "date": "2025-06-09",
   "comptes": 61641,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "cdprojektred.com": {
   "nom": "CD Projekt RED",
   "date": "2016-03-01",
   "comptes": 1871373,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "centraltickets.co.uk": {
   "nom": "Central Tickets",
   "date": "2024-07-01",
   "comptes": 722860,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "achats"
   ]
  },
  "cfgi.com": {
   "nom": "CFGI",
   "date": "2026-03-06",
   "comptes": 248235,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "charter.com": {
   "nom": "Charter",
   "date": "2026-05-23",
   "comptes": 4851517,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "chatbooks.com": {
   "nom": "Chatbooks",
   "date": "2020-03-26",
   "comptes": 2520441,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "cheapassgamer.com": {
   "nom": "CheapAssGamer.com",
   "date": "2015-07-01",
   "comptes": 444767,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "chegg.com": {
   "nom": "Chegg",
   "date": "2018-04-28",
   "comptes": 39721127,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "chess.com": {
   "nom": "Chess.com (2026)",
   "date": "2026-08-03",
   "comptes": 4653212,
   "donnees": [
    "adresses email",
    "localisations",
    "noms",
    "noms d'utilisateur"
   ]
  },
  "csdn.net": {
   "nom": "China Software Developer Network",
   "date": "2011-12-21",
   "comptes": 6414990,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "chowbus.com": {
   "nom": "Chowbus",
   "date": "2020-10-05",
   "comptes": 444224,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "chrisleong.com": {
   "nom": "Chris Leong",
   "date": "2024-08-10",
   "comptes": 27096,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "citybee.lt": {
   "nom": "CityBee",
   "date": "2021-02-05",
   "comptes": 110156,
   "donnees": [
    "adresses email",
    "pièces d'identité",
    "noms",
    "mots de passe"
   ]
  },
  "cityjerks.com": {
   "nom": "CityJerks",
   "date": "2023-02-27",
   "comptes": 177554,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "localisations",
    "adresses IP",
    "mots de passe",
    "messages privés",
    "noms d'utilisateur"
   ]
  },
  "f.elex.com": {
   "nom": "Clash of Kings",
   "date": "2016-07-14",
   "comptes": 1604957,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "clearvoicesurveys.com": {
   "nom": "ClearVoice Surveys",
   "date": "2015-08-23",
   "comptes": 15074786,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "clickasnap.com": {
   "nom": "ClickASnap",
   "date": "2022-09-24",
   "comptes": 3262980,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "adresses postales",
    "achats",
    "noms d'utilisateur"
   ]
  },
  "clixsense.com": {
   "nom": "ClixSense",
   "date": "2016-09-04",
   "comptes": 2424784,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "adresses IP",
    "noms",
    "mots de passe",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "cloudpets.com": {
   "nom": "CloudPets",
   "date": "2017-01-01",
   "comptes": 583503,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "cprewritten.net": {
   "nom": "Club Penguin Rewritten (July 2019)",
   "date": "2019-07-27",
   "comptes": 4007909,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "coachella.com": {
   "nom": "Coachella",
   "date": "2017-02-22",
   "comptes": 599802,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "cocospy.com": {
   "nom": "Cocospy",
   "date": "2025-02-14",
   "comptes": 1798059,
   "donnees": [
    "adresses email"
   ]
  },
  "codestepbystep.com": {
   "nom": "CodeStepByStep",
   "date": "2025-11-15",
   "comptes": 103077,
   "donnees": [
    "adresses email",
    "noms",
    "noms d'utilisateur"
   ]
  },
  "coinmama.com": {
   "nom": "Coinmama",
   "date": "2017-08-03",
   "comptes": 478824,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "coinmarketcap.com": {
   "nom": "CoinMarketCap",
   "date": "2021-10-12",
   "comptes": 3117548,
   "donnees": [
    "adresses email"
   ]
  },
  "cointracker.io": {
   "nom": "CoinTracker",
   "date": "2022-12-01",
   "comptes": 1557153,
   "donnees": [
    "adresses email"
   ]
  },
  "colocrossing.com": {
   "nom": "ColoCrossing",
   "date": "2025-05-24",
   "comptes": 7183,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe"
   ]
  },
  "colordatingapp.com": {
   "nom": "Color Dating",
   "date": "2018-09-05",
   "comptes": 220503,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "localisations",
    "noms",
    "mots de passe"
   ]
  },
  "comcast.net": {
   "nom": "Comcast",
   "date": "2015-11-08",
   "comptes": 616882,
   "donnees": [
    "adresses email",
    "mots de passe",
    "adresses postales"
   ]
  },
  "comelec.gov.ph": {
   "nom": "COMELEC (Philippines Voters)",
   "date": "2016-03-27",
   "comptes": 228605,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "numéros de passeport",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "condo.com": {
   "nom": "Condo.com",
   "date": "2019-06-01",
   "comptes": 1481555,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "convex.ru": {
   "nom": "Convex",
   "date": "2023-02-01",
   "comptes": 150129,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "numéros de téléphone"
   ]
  },
  "covve.com": {
   "nom": "Covve",
   "date": "2020-02-20",
   "comptes": 22802117,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "crackcommunity.com": {
   "nom": "Crack Community",
   "date": "2013-09-09",
   "comptes": 19210,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "cracked.to": {
   "nom": "Cracked.to",
   "date": "2019-07-21",
   "comptes": 749161,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "messages privés",
    "noms d'utilisateur"
   ]
  },
  "crackingforum.com": {
   "nom": "CrackingForum",
   "date": "2016-07-01",
   "comptes": 660305,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "craftrise.com.tr": {
   "nom": "CraftRise",
   "date": "2022-03-05",
   "comptes": 2532527,
   "donnees": [
    "adresses email",
    "localisations",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "creamscafe.com": {
   "nom": "Creams Cafe",
   "date": "2025-05-01",
   "comptes": 159652,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "creative.com": {
   "nom": "Creative",
   "date": "2018-05-01",
   "comptes": 483015,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "cfire.mail.ru": {
   "nom": "Cross Fire",
   "date": "2016-08-08",
   "comptes": 12865609,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "crunchbase.com": {
   "nom": "Crunchbase",
   "date": "2026-01-22",
   "comptes": 559908,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "crunchyroll.com": {
   "nom": "Crunchyroll",
   "date": "2026-03-12",
   "comptes": 1195684,
   "donnees": [
    "adresses email"
   ]
  },
  "ctars.com.au": {
   "nom": "CTARS",
   "date": "2021-05-21",
   "comptes": 12314,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "ctt.pt": {
   "nom": "CTT",
   "date": "2026-04-26",
   "comptes": 468124,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone"
   ]
  },
  "cultura.com": {
   "nom": "Cultura",
   "date": "2024-09-06",
   "comptes": 1462025,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "cushmanwakefield.com": {
   "nom": "Cushman & Wakefield",
   "date": "2026-05-05",
   "comptes": 310431,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "cuties.ai": {
   "nom": "Cuties AI",
   "date": "2025-03-21",
   "comptes": 144250,
   "donnees": [
    "adresses email"
   ]
  },
  "cutout.pro": {
   "nom": "Cutout.Pro",
   "date": "2024-02-26",
   "comptes": 19972829,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe"
   ]
  },
  "cyberserve.co.il": {
   "nom": "CyberServe",
   "date": "2021-10-29",
   "comptes": 1107034,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "messages privés",
    "noms d'utilisateur"
   ]
  },
  "cyrusone.com": {
   "nom": "CyrusOne",
   "date": "2026-08-05",
   "comptes": 373460,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "d3scene.com": {
   "nom": "D3Scene",
   "date": "2016-01-01",
   "comptes": 568827,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "dafont.com": {
   "nom": "DaFont",
   "date": "2017-05-16",
   "comptes": 637340,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "dailyquiz.me": {
   "nom": "Daily Quiz",
   "date": "2021-01-13",
   "comptes": 8032404,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "dailymotion.com": {
   "nom": "Dailymotion",
   "date": "2016-10-20",
   "comptes": 85176234,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "dailyobjects.com": {
   "nom": "DailyObjects",
   "date": "2018-01-01",
   "comptes": 464260,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "dangdang.com": {
   "nom": "Dangdang",
   "date": "2011-06-01",
   "comptes": 4848734,
   "donnees": [
    "adresses email"
   ]
  },
  "daniweb.com": {
   "nom": "DaniWeb",
   "date": "2015-12-01",
   "comptes": 1131636,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe"
   ]
  },
  "datanleads.com": {
   "nom": "Data & Leads",
   "date": "2018-11-14",
   "comptes": 44320330,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "datacamp.com": {
   "nom": "DataCamp",
   "date": "2017-01-30",
   "comptes": 760561,
   "donnees": [
    "adresses email",
    "localisations",
    "adresses IP",
    "noms",
    "mots de passe"
   ]
  },
  "datehotbrunettes.com": {
   "nom": "Date Hot Brunettes",
   "date": "2021-01-12",
   "comptes": 1494078,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "datpiff.com": {
   "nom": "DatPiff",
   "date": "2021-08-25",
   "comptes": 7476940,
   "donnees": [
    "adresses email",
    "mots de passe",
    "questions secrètes",
    "noms d'utilisateur"
   ]
  },
  "dave.com": {
   "nom": "Dave",
   "date": "2020-06-28",
   "comptes": 2964182,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "dbforums.com": {
   "nom": "dBforums",
   "date": "2016-07-04",
   "comptes": 363468,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "dchealthlink.com": {
   "nom": "DC Health Link",
   "date": "2023-03-06",
   "comptes": 48145,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "deezer.com": {
   "nom": "Deezer",
   "date": "2019-04-22",
   "comptes": 229037936,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "adresses IP",
    "noms",
    "noms d'utilisateur"
   ]
  },
  "demandscience.com": {
   "nom": "DemandScience by Pure Incubation",
   "date": "2024-02-28",
   "comptes": 121796165,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "demonforums.net": {
   "nom": "Demon Forums",
   "date": "2019-02-20",
   "comptes": 52623,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "denniskirk.com": {
   "nom": "Dennis Kirk",
   "date": "2021-09-04",
   "comptes": 1356026,
   "donnees": [
    "adresses email",
    "localisations",
    "noms",
    "numéros de téléphone",
    "achats"
   ]
  },
  "dentaquest.com": {
   "nom": "DentaQuest",
   "date": "2026-05-23",
   "comptes": 2553599,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "pièces d'identité",
    "données de santé",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "descomplica.com.br": {
   "nom": "Descomplica",
   "date": "2021-03-14",
   "comptes": 4845378,
   "donnees": [
    "adresses email",
    "noms",
    "données de carte bancaire",
    "mots de passe",
    "achats"
   ]
  },
  "devil-torrents.pl": {
   "nom": "Devil-Torrents.pl",
   "date": "2021-01-04",
   "comptes": 63451,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "devkitpro.org": {
   "nom": "devkitPro",
   "date": "2019-02-03",
   "comptes": 1508,
   "donnees": [
    "adresses email",
    "mots de passe",
    "messages privés"
   ]
  },
  "diet.com": {
   "nom": "diet.com",
   "date": "2014-08-10",
   "comptes": 1383759,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "digidirect.com.au": {
   "nom": "digiDirect",
   "date": "2024-09-29",
   "comptes": 304337,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "diskunion.net": {
   "nom": "Disk Union",
   "date": "2022-06-24",
   "comptes": 690667,
   "donnees": [
    "adresses email",
    "localisations",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "noms d'utilisateur"
   ]
  },
  "disqus.com": {
   "nom": "Disqus",
   "date": "2012-07-01",
   "comptes": 17551044,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "divineskins.gg": {
   "nom": "Divine Skins",
   "date": "2026-03-13",
   "comptes": 105814,
   "donnees": [
    "adresses email",
    "achats",
    "noms d'utilisateur"
   ]
  },
  "divxsubtitles.net": {
   "nom": "DivX SubTitles",
   "date": "2010-01-01",
   "comptes": 783058,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "dlh.net": {
   "nom": "DLH.net",
   "date": "2016-07-31",
   "comptes": 3264710,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "pizza.dominos.be": {
   "nom": "Domino's",
   "date": "2014-06-13",
   "comptes": 648231,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "dominos.co.in": {
   "nom": "Domino's India",
   "date": "2021-03-24",
   "comptes": 22527655,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "doomworld.com": {
   "nom": "Doomworld",
   "date": "2022-10-12",
   "comptes": 34478,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "doordash.com": {
   "nom": "DoorDash",
   "date": "2022-08-02",
   "comptes": 367476,
   "donnees": [
    "adresses email",
    "localisations",
    "noms",
    "données de carte bancaire"
   ]
  },
  "dev.dota2.com": {
   "nom": "Dota2",
   "date": "2016-07-10",
   "comptes": 1907205,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "doublecounter.gg": {
   "nom": "Double Counter",
   "date": "2026-10-04",
   "comptes": 274922,
   "donnees": [
    "adresses email",
    "localisations",
    "noms",
    "noms d'utilisateur"
   ]
  },
  "doxbin.com": {
   "nom": "Doxbin Scrape",
   "date": "2025-01-24",
   "comptes": 435784,
   "donnees": [
    "adresses email"
   ]
  },
  "playdragonica.eu": {
   "nom": "Dragonica Lunaris",
   "date": "2025-12-06",
   "comptes": 126293,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "dragonnest.com": {
   "nom": "DragonNest",
   "date": "2013-08-23",
   "comptes": 511290,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "drivesure.com": {
   "nom": "DriveSure",
   "date": "2020-12-19",
   "comptes": 3675099,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "drizly.com": {
   "nom": "Drizly",
   "date": "2020-07-02",
   "comptes": 2479044,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "dropbox.com": {
   "nom": "Dropbox",
   "date": "2012-07-01",
   "comptes": 68648009,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "dubsmash.com": {
   "nom": "Dubsmash",
   "date": "2018-12-01",
   "comptes": 161749950,
   "donnees": [
    "adresses email",
    "localisations",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "noms d'utilisateur"
   ]
  },
  "ducks.org": {
   "nom": "Ducks Unlimited",
   "date": "2021-01-29",
   "comptes": 1324364,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "duelingnetwork.com": {
   "nom": "Dueling Network",
   "date": "2017-03-29",
   "comptes": 6486626,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "ddo.com": {
   "nom": "Dungeons & Dragons Online",
   "date": "2013-04-02",
   "comptes": 1580933,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "dunzo.com": {
   "nom": "Dunzo",
   "date": "2020-06-19",
   "comptes": 3465259,
   "donnees": [
    "adresses email",
    "localisations",
    "adresses IP",
    "noms",
    "numéros de téléphone"
   ]
  },
  "duolingo.com": {
   "nom": "Duolingo",
   "date": "2023-01-24",
   "comptes": 2676696,
   "donnees": [
    "adresses email",
    "noms",
    "noms d'utilisateur"
   ]
  },
  "dvd-shop.ch": {
   "nom": "dvd-shop.ch",
   "date": "2017-12-05",
   "comptes": 67973,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "dymocks.com.au": {
   "nom": "Dymocks",
   "date": "2023-06-20",
   "comptes": 836120,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "earth2.io": {
   "nom": "Earth 2",
   "date": "2024-10-16",
   "comptes": 420961,
   "donnees": [
    "adresses email",
    "noms d'utilisateur"
   ]
  },
  "eatigo.com": {
   "nom": "Eatigo",
   "date": "2018-10-16",
   "comptes": 2789609,
   "donnees": [
    "adresses email",
    "genres",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "eatstreet.com": {
   "nom": "EatStreet",
   "date": "2019-05-03",
   "comptes": 6353564,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "données de carte bancaire",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "eccie.net": {
   "nom": "ECCIE",
   "date": "2021-07-01",
   "comptes": 536923,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "edmodo.com": {
   "nom": "Edmodo",
   "date": "2017-05-11",
   "comptes": 43423561,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "edmunds.com": {
   "nom": "Edmunds",
   "date": "2026-01-24",
   "comptes": 177860,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "numéros de téléphone",
    "noms d'utilisateur"
   ]
  },
  "elance.com": {
   "nom": "Elance",
   "date": "2009-01-01",
   "comptes": 1291178,
   "donnees": [
    "adresses email",
    "localisations",
    "mots de passe",
    "numéros de téléphone",
    "noms d'utilisateur"
   ]
  },
  "elanic.in": {
   "nom": "Elanic",
   "date": "2018-01-01",
   "comptes": 2325283,
   "donnees": [
    "adresses email",
    "localisations",
    "noms d'utilisateur"
   ]
  },
  "emuparadise.me": {
   "nom": "Emuparadise",
   "date": "2018-04-01",
   "comptes": 1131229,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "ecb.co.uk": {
   "nom": "England Cricket",
   "date": "2024-03-23",
   "comptes": 43299,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "epal.gg": {
   "nom": "E-Pal",
   "date": "2022-04-15",
   "comptes": 108887,
   "donnees": [
    "adresses email",
    "achats",
    "noms d'utilisateur"
   ]
  },
  "epicgames.com": {
   "nom": "Epic Games",
   "date": "2016-08-11",
   "comptes": 251661,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "epicbot.com": {
   "nom": "EpicBot",
   "date": "2019-09-01",
   "comptes": 816662,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "epicnpc.com": {
   "nom": "EpicNPC",
   "date": "2016-01-02",
   "comptes": 408795,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "epik.com": {
   "nom": "Epik",
   "date": "2021-09-13",
   "comptes": 15003961,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "eskimi.com": {
   "nom": "Eskimi",
   "date": "2020-09-25",
   "comptes": 1197620,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "estantevirtual.com.br": {
   "nom": "Estante Virtual",
   "date": "2019-02-28",
   "comptes": 5412603,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "eservices.durban.gov.za": {
   "nom": "eThekwini Municipality",
   "date": "2016-09-07",
   "comptes": 81830,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "pièces d'identité",
    "noms",
    "numéros de passeport",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "ethereum.org": {
   "nom": "Ethereum",
   "date": "2016-12-16",
   "comptes": 16431,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "messages privés",
    "noms d'utilisateur"
   ]
  },
  "eurofiber.com": {
   "nom": "Eurofiber",
   "date": "2025-11-13",
   "comptes": 10003,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone"
   ]
  },
  "europa.jobs": {
   "nom": "europa.jobs",
   "date": "2019-08-11",
   "comptes": 226095,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "localisations",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "evermotion.org": {
   "nom": "Evermotion",
   "date": "2015-05-07",
   "comptes": 435510,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "everybodyedits.com": {
   "nom": "Everybody Edits",
   "date": "2019-03-23",
   "comptes": 871190,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms d'utilisateur"
   ]
  },
  "evite.com": {
   "nom": "Evite",
   "date": "2013-08-11",
   "comptes": 100985047,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "evony.com": {
   "nom": "Evony",
   "date": "2016-06-01",
   "comptes": 29396116,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "exactsciences.com": {
   "nom": "Exact Sciences",
   "date": "2026-07-15",
   "comptes": 10869543,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "exactis.com": {
   "nom": "Exactis",
   "date": "2018-06-01",
   "comptes": 131577763,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "adresses IP",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "exploretalent.com": {
   "nom": "Explore Talent (August 2024)",
   "date": "2024-08-15",
   "comptes": 8929384,
   "donnees": [
    "adresses email"
   ]
  },
  "exvagos.org": {
   "nom": "Exvagos",
   "date": "2022-07-21",
   "comptes": 2121789,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "eye4fraud.com": {
   "nom": "Eye4Fraud",
   "date": "2023-01-25",
   "comptes": 16000591,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "données de carte bancaire",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "eyeem.com": {
   "nom": "EyeEm",
   "date": "2018-02-28",
   "comptes": 19611022,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "facebook.com": {
   "nom": "Facebook Marketplace",
   "date": "2023-10-01",
   "comptes": 77267,
   "donnees": [
    "adresses email",
    "localisations",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "facepunch.com": {
   "nom": "Facepunch",
   "date": "2016-06-03",
   "comptes": 342913,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "faceup.dk": {
   "nom": "FaceUP",
   "date": "2013-01-01",
   "comptes": 87633,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "noms d'utilisateur"
   ]
  },
  "factual.com": {
   "nom": "Factual",
   "date": "2017-03-22",
   "comptes": 2461696,
   "donnees": [
    "adresses email",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "fairvote.ca": {
   "nom": "Fair Vote Canada",
   "date": "2024-03-02",
   "comptes": 134336,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "famm.us": {
   "nom": "Famm",
   "date": "2020-10-08",
   "comptes": 535240,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "mots de passe"
   ]
  },
  "fanlore.org": {
   "nom": "Fanlore",
   "date": "2026-08-06",
   "comptes": 144520,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "fanpass.co.uk": {
   "nom": "Fanpass",
   "date": "2022-04-30",
   "comptes": 112251,
   "donnees": [
    "adresses email",
    "genres",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "fantasyfootballhub.co.uk": {
   "nom": "Fantasy Football Hub",
   "date": "2021-10-02",
   "comptes": 66479,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "achats",
    "noms d'utilisateur"
   ]
  },
  "fashionnexus.co.uk": {
   "nom": "Fashion Nexus",
   "date": "2018-07-09",
   "comptes": 1279263,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "fashionfantasygame.com": {
   "nom": "FashionFantasyGame",
   "date": "2016-12-01",
   "comptes": 2357872,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "ffr.fr": {
   "nom": "Fédération Francaise de Rugby",
   "date": "2023-07-06",
   "comptes": 281977,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "numéros de téléphone"
   ]
  },
  "figure.com": {
   "nom": "Figure",
   "date": "2026-01-28",
   "comptes": 967178,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "filmai.in": {
   "nom": "Filmai.in",
   "date": "2020-01-01",
   "comptes": 645786,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "ffshrine.org": {
   "nom": "Final Fantasy Shrine",
   "date": "2015-09-18",
   "comptes": 620677,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "finsure.com.au": {
   "nom": "Finsure",
   "date": "2024-10-15",
   "comptes": 296124,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "fitmart.de": {
   "nom": "Fitmart",
   "date": "2021-10-01",
   "comptes": 214492,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "flashflashrevolution.com": {
   "nom": "Flash Flash Revolution (2019 breach)",
   "date": "2019-07-16",
   "comptes": 1858124,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "flashback.se": {
   "nom": "Flashback",
   "date": "2015-02-11",
   "comptes": 40256,
   "donnees": [
    "adresses email",
    "pièces d'identité",
    "adresses postales"
   ]
  },
  "flatearthdave.com": {
   "nom": "Flat Earth Sun, Moon and Zodiac App",
   "date": "2024-10-15",
   "comptes": 33294,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "flexbooker.com": {
   "nom": "FlexBooker",
   "date": "2021-12-23",
   "comptes": 3756794,
   "donnees": [
    "adresses email",
    "noms",
    "données de carte bancaire",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "fling.com": {
   "nom": "Fling",
   "date": "2011-03-10",
   "comptes": 40767652,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "adresses IP",
    "mots de passe",
    "numéros de téléphone",
    "noms d'utilisateur"
   ]
  },
  "flipaclip.com": {
   "nom": "FlipaClip",
   "date": "2024-11-18",
   "comptes": 892854,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "localisations",
    "noms"
   ]
  },
  "flvs.net": {
   "nom": "Florida Virtual School",
   "date": "2018-02-12",
   "comptes": 542902,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "fluke.com": {
   "nom": "Fluke",
   "date": "2026-07-01",
   "comptes": 821100,
   "donnees": [
    "adresses email",
    "noms",
    "adresses postales"
   ]
  },
  "fntech.com": {
   "nom": "FNTECH",
   "date": "2024-07-04",
   "comptes": 10386,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms"
   ]
  },
  "foodora.com": {
   "nom": "Foodora",
   "date": "2016-04-22",
   "comptes": 582578,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "forbes.com": {
   "nom": "Forbes",
   "date": "2014-02-15",
   "comptes": 1057819,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "forumcommunity.net": {
   "nom": "ForumCommunity",
   "date": "2016-06-01",
   "comptes": 776648,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "fotolog.com": {
   "nom": "Fotolog",
   "date": "2018-12-01",
   "comptes": 16717854,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "foxybingo.com": {
   "nom": "Foxy Bingo",
   "date": "2008-04-04",
   "comptes": 252216,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "frameandoptic.com": {
   "nom": "Frame & Optic",
   "date": "2025-01-16",
   "comptes": 15678,
   "donnees": [
    "adresses email",
    "localisations",
    "noms",
    "numéros de téléphone"
   ]
  },
  "free.fr": {
   "nom": "Free",
   "date": "2024-10-17",
   "comptes": 13926173,
   "donnees": [
    "comptes bancaires",
    "dates de naissance",
    "genres",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "fhostingesps6bly.onion": {
   "nom": "Freedom Hosting II",
   "date": "2017-01-31",
   "comptes": 380830,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "freeones.com": {
   "nom": "FreeOnes",
   "date": "2017-02-16",
   "comptes": 960213,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "freshmenu.com": {
   "nom": "FreshMenu",
   "date": "2016-07-01",
   "comptes": 110355,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "fridae.asia": {
   "nom": "Fridae",
   "date": "2014-05-02",
   "comptes": 35368,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "funimation.com": {
   "nom": "Funimation",
   "date": "2016-07-01",
   "comptes": 2491103,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "funny-games.biz": {
   "nom": "Funny Games",
   "date": "2018-04-28",
   "comptes": 764357,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "furaffinity.net": {
   "nom": "Fur Affinity",
   "date": "2016-05-17",
   "comptes": 1270564,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "gaadi.com": {
   "nom": "Gaadi",
   "date": "2015-05-14",
   "comptes": 4261179,
   "donnees": [
    "adresses email",
    "genres",
    "localisations",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "noms d'utilisateur"
   ]
  },
  "gab.com": {
   "nom": "Gab",
   "date": "2021-02-26",
   "comptes": 66521,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "messages privés",
    "noms d'utilisateur"
   ]
  },
  "gamerzplanet.net": {
   "nom": "Gamerzplanet",
   "date": "2015-10-23",
   "comptes": 1217166,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "gamesbox.com": {
   "nom": "Games Box",
   "date": "2020-09-21",
   "comptes": 1439354,
   "donnees": [
    "adresses email",
    "genres",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "gamesalad.com": {
   "nom": "GameSalad",
   "date": "2019-02-24",
   "comptes": 1506242,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "gamesprite.me": {
   "nom": "GameSprite",
   "date": "2019-12-17",
   "comptes": 6164643,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "game-tuts.com": {
   "nom": "GameTuts",
   "date": "2015-03-01",
   "comptes": 2064274,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "gamevn.com": {
   "nom": "GameVN",
   "date": "2016-05-01",
   "comptes": 1369485,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "gamigo.com": {
   "nom": "Gamigo",
   "date": "2012-03-01",
   "comptes": 8243604,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "gamingmonk.com": {
   "nom": "GamingMonk",
   "date": "2020-12-02",
   "comptes": 654510,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "noms d'utilisateur"
   ]
  },
  "gatehub.net": {
   "nom": "GateHub",
   "date": "2019-06-04",
   "comptes": 1408078,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "gawker.com": {
   "nom": "Gawker",
   "date": "2010-12-11",
   "comptes": 1247574,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "ge.tt": {
   "nom": "Ge.tt",
   "date": "2017-05-04",
   "comptes": 2481121,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe"
   ]
  },
  "geekedin.net": {
   "nom": "GeekedIn",
   "date": "2016-08-15",
   "comptes": 1073164,
   "donnees": [
    "adresses email",
    "localisations",
    "noms",
    "noms d'utilisateur"
   ]
  },
  "gemini.com": {
   "nom": "Gemini",
   "date": "2022-12-13",
   "comptes": 5274214,
   "donnees": [
    "adresses email"
   ]
  },
  "gemplex.tv": {
   "nom": "Gemplex",
   "date": "2021-02-18",
   "comptes": 4563166,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "genesis.market": {
   "nom": "Genesis Market",
   "date": "2023-04-05",
   "comptes": 8000000,
   "donnees": [
    "cartes bancaires",
    "dates de naissance",
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "geniusu.com": {
   "nom": "GeniusU",
   "date": "2020-10-02",
   "comptes": 1301460,
   "donnees": [
    "adresses email",
    "genres",
    "adresses IP",
    "noms",
    "mots de passe"
   ]
  },
  "germandonerkebab.com": {
   "nom": "German Doner Kebab",
   "date": "2025-03-27",
   "comptes": 162373,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "getrevengeonyourex.com": {
   "nom": "Get Revenge On Your Ex",
   "date": "2022-09-09",
   "comptes": 79195,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "ggcorp.me": {
   "nom": "GGCorp",
   "date": "2022-08-11",
   "comptes": 2376330,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "gianttiger.com": {
   "nom": "Giant Tiger",
   "date": "2024-03-04",
   "comptes": 2842669,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "giglio.com": {
   "nom": "Giglio",
   "date": "2025-08-09",
   "comptes": 1026468,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "givesendgo.com": {
   "nom": "GiveSendGo",
   "date": "2022-02-07",
   "comptes": 89966,
   "donnees": [
    "adresses email",
    "localisations",
    "noms",
    "achats"
   ]
  },
  "glamira.com": {
   "nom": "GLAMIRA",
   "date": "2023-12-16",
   "comptes": 874594,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "achats"
   ]
  },
  "glendale.edu": {
   "nom": "Glendale Community College",
   "date": "2026-06-15",
   "comptes": 793925,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "pièces d'identité",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "glofox.com": {
   "nom": "Glofox",
   "date": "2020-03-27",
   "comptes": 2330735,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "gogames.me": {
   "nom": "Go Games",
   "date": "2015-10-24",
   "comptes": 3430083,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "goninja.de": {
   "nom": "Go Ninja",
   "date": "2019-12-17",
   "comptes": 4999001,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "goldsilver.com": {
   "nom": "GoldSilver",
   "date": "2018-10-21",
   "comptes": 242715,
   "donnees": [
    "comptes bancaires",
    "adresses email",
    "adresses IP",
    "noms",
    "données de carte bancaire",
    "numéros de passeport",
    "numéros de téléphone",
    "adresses postales",
    "achats",
    "questions secrètes"
   ]
  },
  "golfcanada.ca": {
   "nom": "Golf Canada",
   "date": "2026-05-14",
   "comptes": 568972,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "noms",
    "noms d'utilisateur"
   ]
  },
  "goosecreek.com": {
   "nom": "Goose Creek",
   "date": "2026-06-09",
   "comptes": 6574121,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "gpotato.com": {
   "nom": "gPotato",
   "date": "2007-07-12",
   "comptes": 2136520,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "adresses IP",
    "noms",
    "mots de passe",
    "adresses postales",
    "questions secrètes",
    "noms d'utilisateur"
   ]
  },
  "gpsunderground.com": {
   "nom": "GPS Underground",
   "date": "2016-07-01",
   "comptes": 669584,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "gravatar.com": {
   "nom": "Gravatar",
   "date": "2020-10-03",
   "comptes": 113990759,
   "donnees": [
    "adresses email",
    "noms",
    "noms d'utilisateur"
   ]
  },
  "gsmhosting.com": {
   "nom": "GSM Hosting",
   "date": "2016-08-01",
   "comptes": 2607440,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "gtagaming.com": {
   "nom": "GTAGaming",
   "date": "2016-08-01",
   "comptes": 197184,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "gunauction.com": {
   "nom": "GunAuction.com",
   "date": "2022-12-03",
   "comptes": 565470,
   "donnees": [
    "adresses email",
    "genres",
    "adresses IP",
    "données de carte bancaire",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "play-gar.com": {
   "nom": "Guns and Robots",
   "date": "2016-04-01",
   "comptes": 143569,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "guns.com": {
   "nom": "Guns.com",
   "date": "2021-01-12",
   "comptes": 375928,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "données de carte bancaire",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "guntrader.uk": {
   "nom": "Guntrader",
   "date": "2021-07-17",
   "comptes": 112031,
   "donnees": [
    "adresses email",
    "localisations",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "hackforums.net": {
   "nom": "hackforums.net",
   "date": "2011-06-25",
   "comptes": 191540,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "hackingteam.com": {
   "nom": "Hacking Team",
   "date": "2015-07-06",
   "comptes": 32310,
   "donnees": [
    "adresses email"
   ]
  },
  "hakko.com": {
   "nom": "Hakko Corporation",
   "date": "2019-03-28",
   "comptes": 9665,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "hallmark.com": {
   "nom": "Hallmark",
   "date": "2026-03-31",
   "comptes": 1736520,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "hathway.com": {
   "nom": "Hathway",
   "date": "2023-12-17",
   "comptes": 4670080,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "hautelook.com": {
   "nom": "HauteLook",
   "date": "2018-08-07",
   "comptes": 28510459,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "noms",
    "mots de passe"
   ]
  },
  "havefunteaching.com": {
   "nom": "Have Fun Teaching",
   "date": "2021-08-15",
   "comptes": 27126,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "adresses postales",
    "achats"
   ]
  },
  "havenly.com": {
   "nom": "Havenly",
   "date": "2020-06-25",
   "comptes": 1369180,
   "donnees": [
    "adresses email",
    "localisations",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "hdbfs.com": {
   "nom": "HDB Financial Services",
   "date": "2023-02-22",
   "comptes": 1658750,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "noms",
    "numéros de téléphone"
   ]
  },
  "healthnow.co": {
   "nom": "Health Now Networks",
   "date": "2017-03-25",
   "comptes": 321920,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "données de santé",
    "adresses IP",
    "noms",
    "numéros de téléphone",
    "adresses postales",
    "questions secrètes"
   ]
  },
  "heatgames.me": {
   "nom": "HeatGames",
   "date": "2021-06-12",
   "comptes": 647896,
   "donnees": [
    "adresses email",
    "localisations",
    "adresses IP",
    "mots de passe"
   ]
  },
  "hellocake.com": {
   "nom": "Hello Cake",
   "date": "2025-07-25",
   "comptes": 22907,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "hemmakvall.se": {
   "nom": "Hemmakväll",
   "date": "2015-07-08",
   "comptes": 47297,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "hemmelig.com": {
   "nom": "hemmelig.com",
   "date": "2011-12-21",
   "comptes": 28641,
   "donnees": [
    "adresses email",
    "genres",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "heroesofgaia.com": {
   "nom": "Heroes of Gaia",
   "date": "2013-01-04",
   "comptes": 179967,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms d'utilisateur"
   ]
  },
  "heroesofnewerth.com": {
   "nom": "Heroes of Newerth",
   "date": "2012-12-17",
   "comptes": 8089103,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "hjedd.com": {
   "nom": "Hjedd",
   "date": "2022-07-18",
   "comptes": 13204029,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "hltv.org": {
   "nom": "HLTV",
   "date": "2016-06-19",
   "comptes": 611070,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "homechef.com": {
   "nom": "Home Chef",
   "date": "2020-02-10",
   "comptes": 8815692,
   "donnees": [
    "adresses email",
    "localisations",
    "adresses IP",
    "noms",
    "données de carte bancaire",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "homerefill.com.br": {
   "nom": "HomeRefill",
   "date": "2020-04-02",
   "comptes": 187457,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "hongfire.com": {
   "nom": "HongFire",
   "date": "2015-03-01",
   "comptes": 999991,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "hookers.nl": {
   "nom": "Hookers.nl",
   "date": "2019-10-10",
   "comptes": 290955,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "horseisle.com": {
   "nom": "Horse Isle",
   "date": "2020-09-19",
   "comptes": 27786,
   "donnees": [
    "adresses email",
    "genres",
    "adresses IP",
    "noms",
    "mots de passe",
    "achats",
    "noms d'utilisateur"
   ]
  },
  "hottopic.com": {
   "nom": "Hot Topic",
   "date": "2024-10-19",
   "comptes": 56904909,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "données de carte bancaire",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "hounddawgs.org": {
   "nom": "HoundDawgs",
   "date": "2017-12-30",
   "comptes": 45701,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe"
   ]
  },
  "hccs.edu": {
   "nom": "Houston City College",
   "date": "2026-06-16",
   "comptes": 831642,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "houzz.com": {
   "nom": "Houzz",
   "date": "2018-05-23",
   "comptes": 48881308,
   "donnees": [
    "adresses email",
    "localisations",
    "adresses IP",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "htcmania.com": {
   "nom": "HTC Mania",
   "date": "2020-01-04",
   "comptes": 1488089,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "hthstudios.com": {
   "nom": "HTH Studios",
   "date": "2018-08-24",
   "comptes": 411755,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "noms",
    "numéros de téléphone",
    "adresses postales",
    "achats",
    "noms d'utilisateur"
   ]
  },
  "hub4tech.com": {
   "nom": "Hub4Tech",
   "date": "2017-01-01",
   "comptes": 36916,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "huntstand.com": {
   "nom": "HuntStand",
   "date": "2024-03-08",
   "comptes": 2795947,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "localisations",
    "noms"
   ]
  },
  "hurb.com": {
   "nom": "Hurb",
   "date": "2019-03-14",
   "comptes": 20727771,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "husky-owners.com": {
   "nom": "Husky Owners",
   "date": "2024-07-04",
   "comptes": 16502,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms d'utilisateur"
   ]
  },
  "idtech.com": {
   "nom": "iD Tech",
   "date": "2023-01-03",
   "comptes": 415121,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "mots de passe"
   ]
  },
  "idcgames.com": {
   "nom": "IDC Games",
   "date": "2021-03-15",
   "comptes": 3966871,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "i-dressup.com": {
   "nom": "i-Dressup",
   "date": "2016-07-15",
   "comptes": 2191565,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "iimjobs.com": {
   "nom": "IIMJobs",
   "date": "2018-12-31",
   "comptes": 4216063,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "localisations",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "ilikecheats.net": {
   "nom": "ILikeCheats",
   "date": "2014-10-18",
   "comptes": 188847,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "imavex.com": {
   "nom": "Imavex",
   "date": "2021-08-20",
   "comptes": 878209,
   "donnees": [
    "adresses email",
    "genres",
    "noms",
    "données de carte bancaire",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "achats",
    "noms d'utilisateur"
   ]
  },
  "imenu360.com": {
   "nom": "iMenu360",
   "date": "2022-08-11",
   "comptes": 3425860,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "imesh.com": {
   "nom": "iMesh",
   "date": "2013-09-22",
   "comptes": 49467477,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "imgur.com": {
   "nom": "imgur",
   "date": "2013-09-01",
   "comptes": 1749806,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "indiamart.com": {
   "nom": "IndiaMART",
   "date": "2021-05-23",
   "comptes": 20154583,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "indianrails.in": {
   "nom": "Indian Railways",
   "date": "2019-10-28",
   "comptes": 583377,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "indihome.co.id": {
   "nom": "IndiHome",
   "date": "2019-11-01",
   "comptes": 12629245,
   "donnees": [
    "adresses email",
    "genres",
    "localisations",
    "adresses IP",
    "noms"
   ]
  },
  "infinitecampus.com": {
   "nom": "Infinite Campus",
   "date": "2026-03-18",
   "comptes": 137123,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "tube.inflatevids.xyz": {
   "nom": "InflateVids",
   "date": "2023-12-12",
   "comptes": 13405,
   "donnees": [
    "adresses email",
    "genres",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "insanelyi.com": {
   "nom": "Insanelyi",
   "date": "2014-07-22",
   "comptes": 104097,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "instagram.com": {
   "nom": "Instagram",
   "date": "2026-01-07",
   "comptes": 6215150,
   "donnees": [
    "adresses email",
    "localisations",
    "numéros de téléphone",
    "noms d'utilisateur"
   ]
  },
  "instantcheckmate.com": {
   "nom": "Instant Checkmate",
   "date": "2019-04-12",
   "comptes": 11943887,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "ind.cl": {
   "nom": "Instituto Nacional de Deportes de Chile",
   "date": "2024-09-12",
   "comptes": 319613,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "icsecurity.com": {
   "nom": "Inter-Con Security",
   "date": "2026-06-18",
   "comptes": 276114,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "ikointl.com": {
   "nom": "International Kiteboarding Organization",
   "date": "2025-11-11",
   "comptes": 340349,
   "donnees": [
    "adresses email",
    "localisations",
    "noms",
    "noms d'utilisateur"
   ]
  },
  "archive.org": {
   "nom": "Internet Archive",
   "date": "2024-09-28",
   "comptes": 31081179,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "interpals.net": {
   "nom": "InterPals",
   "date": "2015-11-04",
   "comptes": 3439414,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "localisations",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "ipmart-forum.com": {
   "nom": "iPmart",
   "date": "2015-07-01",
   "comptes": 2460787,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "ixigo.com": {
   "nom": "ixigo",
   "date": "2019-01-03",
   "comptes": 17204697,
   "donnees": [
    "jetons d'accès",
    "adresses email",
    "genres",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "noms d'utilisateur"
   ]
  },
  "jamtangan.com": {
   "nom": "Jam Tangan",
   "date": "2021-07-06",
   "comptes": 434784,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "jamesdelivery.com.br": {
   "nom": "James",
   "date": "2020-03-25",
   "comptes": 1541284,
   "donnees": [
    "adresses email",
    "localisations",
    "mots de passe"
   ]
  },
  "jcpenny.com": {
   "nom": "JCPenney",
   "date": "2026-06-12",
   "comptes": 368418,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "pièces d'identité",
    "noms",
    "numéros de téléphone",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "jd.com": {
   "nom": "JD",
   "date": "2013-01-01",
   "comptes": 77449341,
   "donnees": [
    "adresses email",
    "mots de passe",
    "numéros de téléphone",
    "noms d'utilisateur"
   ]
  },
  "jdgroup.co.za": {
   "nom": "JD Group",
   "date": "2023-05-31",
   "comptes": 521878,
   "donnees": [
    "adresses email",
    "pièces d'identité",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "jefit.com": {
   "nom": "Jefit",
   "date": "2020-08-11",
   "comptes": 9052457,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "jobandtalent.com": {
   "nom": "Jobandtalent",
   "date": "2018-02-01",
   "comptes": 10981207,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe"
   ]
  },
  "jobstreet.com": {
   "nom": "JobStreet",
   "date": "2012-03-07",
   "comptes": 3883455,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "pièces d'identité",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "jobzone.co.il": {
   "nom": "Jobzone",
   "date": "2023-04-15",
   "comptes": 29708,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "pièces d'identité",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "joomlart.com": {
   "nom": "JoomlArt",
   "date": "2018-01-30",
   "comptes": 22477,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "joygames.me": {
   "nom": "JoyGames",
   "date": "2019-12-14",
   "comptes": 4461787,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "jukinmedia.com": {
   "nom": "JukinMedia",
   "date": "2021-10-28",
   "comptes": 314290,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "kaneva.com": {
   "nom": "Kaneva",
   "date": "2016-07-01",
   "comptes": 3901179,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "kasperskyclub.ru": {
   "nom": "Kaspersky Club",
   "date": "2024-03-24",
   "comptes": 55971,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "kemper.com": {
   "nom": "Kemper",
   "date": "2026-04-15",
   "comptes": 269299,
   "donnees": [
    "adresses email",
    "noms",
    "données de carte bancaire",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "kickstarter.com": {
   "nom": "Kickstarter",
   "date": "2014-02-16",
   "comptes": 5176463,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "kimsufi.com": {
   "nom": "Kimsufi",
   "date": "2015-05-01",
   "comptes": 504565,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "kinokong.org": {
   "nom": "KinoKong",
   "date": "2021-03-25",
   "comptes": 817808,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "kitchenpalapp.com": {
   "nom": "KitchenPal",
   "date": "2023-11-14",
   "comptes": 98726,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "noms",
    "mots de passe"
   ]
  },
  "kiwifarms.net": {
   "nom": "KiwiFarms",
   "date": "2019-09-10",
   "comptes": 4606,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP"
   ]
  },
  "km.ru": {
   "nom": "KM.RU",
   "date": "2016-02-29",
   "comptes": 1476783,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "questions secrètes",
    "noms d'utilisateur"
   ]
  },
  "knowncircle.com": {
   "nom": "KnownCircle",
   "date": "2016-04-12",
   "comptes": 1957600,
   "donnees": [
    "adresses email",
    "genres",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "knuddels.de": {
   "nom": "Knuddels",
   "date": "2018-09-05",
   "comptes": 808330,
   "donnees": [
    "adresses email",
    "localisations",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "komiko.app": {
   "nom": "KomikoAI",
   "date": "2026-02-25",
   "comptes": 1060191,
   "donnees": [
    "adresses email",
    "noms"
   ]
  },
  "komplettfritid.no": {
   "nom": "KomplettFritid",
   "date": "2021-02-01",
   "comptes": 139401,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "kreditplus.com": {
   "nom": "Kreditplus",
   "date": "2020-06-23",
   "comptes": 768890,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "lapostemobile.fr": {
   "nom": "La Poste Mobile",
   "date": "2022-07-04",
   "comptes": 533886,
   "donnees": [
    "comptes bancaires",
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "ladies.com": {
   "nom": "Ladies.com",
   "date": "2024-07-03",
   "comptes": 118809,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "noms d'utilisateur"
   ]
  },
  "landairsea.com": {
   "nom": "LandAirSea",
   "date": "2025-01-12",
   "comptes": 337373,
   "donnees": [
    "adresses email",
    "noms",
    "données de carte bancaire",
    "mots de passe",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "lanwar.com": {
   "nom": "Lanwar",
   "date": "2018-07-28",
   "comptes": 45120,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "last.fm": {
   "nom": "Last.fm",
   "date": "2012-03-22",
   "comptes": 37217682,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "latestpilotjobs.com": {
   "nom": "Latest Pilot Jobs",
   "date": "2022-08-14",
   "comptes": 118864,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "redmart.lazada.sg": {
   "nom": "Lazada RedMart",
   "date": "2020-07-30",
   "comptes": 1107789,
   "donnees": [
    "adresses email",
    "noms",
    "données de carte bancaire",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "lbb.in": {
   "nom": "LBB",
   "date": "2019-02-14",
   "comptes": 39288,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "adresses postales"
   ]
  },
  "ldlc.com": {
   "nom": "LDLC",
   "date": "2024-02-28",
   "comptes": 1266026,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "lecoqsportif.com.co": {
   "nom": "Le Coq Sportif Columbia",
   "date": "2023-05-01",
   "comptes": 79712,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "adresses IP",
    "noms",
    "mots de passe",
    "adresses postales",
    "achats"
   ]
  },
  "leslipfrancais.fr": {
   "nom": "Le Slip Français",
   "date": "2024-04-13",
   "comptes": 1495127,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "leagueoflegends.com": {
   "nom": "League of Legends",
   "date": "2012-06-11",
   "comptes": 339487,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "leakedreality.com": {
   "nom": "Leaked Reality",
   "date": "2022-01-31",
   "comptes": 114907,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "ledger.com": {
   "nom": "Ledger",
   "date": "2020-06-25",
   "comptes": 1075241,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "leet.cc": {
   "nom": "Leet",
   "date": "2016-09-10",
   "comptes": 5081689,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "legendas.tv": {
   "nom": "Legendas.TV",
   "date": "2017-10-01",
   "comptes": 3869181,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "legionproxy.io": {
   "nom": "LegionProxy",
   "date": "2026-04-06",
   "comptes": 10144,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "achats"
   ]
  },
  "lexipol.com": {
   "nom": "Lexipol",
   "date": "2025-02-11",
   "comptes": 672546,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "noms d'utilisateur"
   ]
  },
  "life360.com": {
   "nom": "Life360",
   "date": "2024-03-01",
   "comptes": 442519,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone"
   ]
  },
  "lifebear.com": {
   "nom": "Lifebear",
   "date": "2019-02-28",
   "comptes": 3670561,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "lbsg.net": {
   "nom": "Lifeboat",
   "date": "2016-01-01",
   "comptes": 7089395,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "lightshope.org": {
   "nom": "Light's Hope",
   "date": "2018-06-25",
   "comptes": 30484,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "localisations",
    "adresses IP",
    "mots de passe",
    "messages privés",
    "noms d'utilisateur"
   ]
  },
  "liker.com": {
   "nom": "Liker",
   "date": "2021-03-08",
   "comptes": 465141,
   "donnees": [
    "jetons d'accès",
    "dates de naissance",
    "adresses email",
    "localisations",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "messages privés",
    "questions secrètes",
    "noms d'utilisateur"
   ]
  },
  "limeleads.com": {
   "nom": "LimeLeads",
   "date": "2019-08-01",
   "comptes": 17838396,
   "donnees": [
    "adresses email",
    "localisations",
    "numéros de téléphone"
   ]
  },
  "limevpn.com": {
   "nom": "LimeVPN",
   "date": "2020-10-08",
   "comptes": 23348,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "linkedin.com": {
   "nom": "LinkedIn Scraped Data (2021)",
   "date": "2021-04-08",
   "comptes": 125698496,
   "donnees": [
    "adresses email",
    "genres",
    "localisations",
    "noms"
   ]
  },
  "linuxforums.org": {
   "nom": "Linux Forums",
   "date": "2018-05-01",
   "comptes": 275785,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "linuxmint.com": {
   "nom": "Linux Mint",
   "date": "2016-02-21",
   "comptes": 144989,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "localisations",
    "adresses IP",
    "mots de passe"
   ]
  },
  "littlemonsters.com": {
   "nom": "Little Monsters",
   "date": "2017-01-01",
   "comptes": 995698,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "liveauctioneers.com": {
   "nom": "LiveAuctioneers",
   "date": "2020-06-19",
   "comptes": 3385862,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "livejournal.com": {
   "nom": "LiveJournal",
   "date": "2017-01-01",
   "comptes": 26372781,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "livpure.com": {
   "nom": "Livpure",
   "date": "2020-08-29",
   "comptes": 269552,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "lizardstresser.su": {
   "nom": "Lizard Squad",
   "date": "2015-01-16",
   "comptes": 13451,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "locally.com": {
   "nom": "Locally",
   "date": "2022-10-01",
   "comptes": 362619,
   "donnees": [
    "adresses email",
    "données de carte bancaire",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "lolzteam.net": {
   "nom": "Lolzteam",
   "date": "2018-05-13",
   "comptes": 398011,
   "donnees": [
    "adresses email",
    "noms d'utilisateur"
   ]
  },
  "lookbook.nu": {
   "nom": "Lookbook",
   "date": "2012-08-24",
   "comptes": 1074948,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "lookiero.com": {
   "nom": "Lookiero",
   "date": "2024-03-27",
   "comptes": 4981760,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "lotro.com": {
   "nom": "Lord of the Rings Online",
   "date": "2013-08-01",
   "comptes": 1141278,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "loungeboard.net": {
   "nom": "Lounge Board",
   "date": "2013-08-01",
   "comptes": 45018,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "messages privés",
    "noms d'utilisateur"
   ]
  },
  "luluhypermarket.com": {
   "nom": "LuLu",
   "date": "2024-07-06",
   "comptes": 2796835,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "luminpdf.com": {
   "nom": "Lumin PDF",
   "date": "2019-04-01",
   "comptes": 15453048,
   "donnees": [
    "jetons d'accès",
    "adresses email",
    "genres",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "luxottica.com": {
   "nom": "Luxottica",
   "date": "2021-03-16",
   "comptes": 77093812,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "lyricsmania.com": {
   "nom": "Lyrics Mania",
   "date": "2017-12-21",
   "comptes": 109202,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "mac-forums.com": {
   "nom": "Mac Forums",
   "date": "2016-07-03",
   "comptes": 326714,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "macg.co": {
   "nom": "MacGeneration",
   "date": "2022-01-29",
   "comptes": 101004,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "mac-torrents.com": {
   "nom": "Mac-Torrents",
   "date": "2015-10-31",
   "comptes": 93992,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "msgsports.com": {
   "nom": "Madison Square Garden Sports",
   "date": "2026-06-05",
   "comptes": 9796738,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "magicduel.com": {
   "nom": "MagicDuel",
   "date": "2023-08-02",
   "comptes": 138443,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe"
   ]
  },
  "majorgeeks.com": {
   "nom": "MajorGeeks",
   "date": "2015-11-15",
   "comptes": 269548,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "malindoair.com": {
   "nom": "MalindoAir",
   "date": "2019-03-01",
   "comptes": 4328232,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "numéros de passeport",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "mall.cz": {
   "nom": "MALL.cz",
   "date": "2017-07-27",
   "comptes": 735405,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "malwarebytes.org": {
   "nom": "Malwarebytes",
   "date": "2014-11-15",
   "comptes": 111623,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "magairports.com": {
   "nom": "Manchester Airports Group",
   "date": "2026-08-27",
   "comptes": 8849657,
   "donnees": [
    "adresses email",
    "localisations",
    "adresses IP",
    "noms",
    "numéros de téléphone",
    "achats"
   ]
  },
  "mangatraders.com": {
   "nom": "Manga Traders",
   "date": "2014-06-09",
   "comptes": 855249,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "mangadex.org": {
   "nom": "MangaDex",
   "date": "2021-03-22",
   "comptes": 2987329,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "mangafox.me": {
   "nom": "MangaFox.me",
   "date": "2016-06-01",
   "comptes": 1311610,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "mangatoon.mobi": {
   "nom": "Mangatoon",
   "date": "2022-05-13",
   "comptes": 23040238,
   "donnees": [
    "jetons d'accès",
    "adresses email",
    "genres",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "mappery.com": {
   "nom": "Mappery",
   "date": "2018-12-11",
   "comptes": 205242,
   "donnees": [
    "adresses email",
    "localisations",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "marcusmillichap.com": {
   "nom": "Marcus & Millichap",
   "date": "2026-04-12",
   "comptes": 1837078,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "mareads.com": {
   "nom": "MaReads",
   "date": "2025-06-22",
   "comptes": 74453,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "numéros de téléphone",
    "noms d'utilisateur"
   ]
  },
  "marketmoveis.pt": {
   "nom": "Market Moveis",
   "date": "2023-08-30",
   "comptes": 28220,
   "donnees": [
    "adresses email",
    "noms"
   ]
  },
  "mashable.com": {
   "nom": "Mashable",
   "date": "2020-06-01",
   "comptes": 1414677,
   "donnees": [
    "jetons d'accès",
    "adresses email",
    "genres",
    "localisations",
    "adresses IP",
    "noms"
   ]
  },
  "specials.mastercard.de": {
   "nom": "Mastercard Priceless Specials",
   "date": "2019-08-20",
   "comptes": 89388,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "données de carte bancaire",
    "numéros de téléphone"
   ]
  },
  "mate1.com": {
   "nom": "Mate1.com",
   "date": "2016-02-29",
   "comptes": 27393015,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "mathway.com": {
   "nom": "Mathway",
   "date": "2020-01-13",
   "comptes": 25692862,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe"
   ]
  },
  "mcbans.com": {
   "nom": "MCBans",
   "date": "2016-10-27",
   "comptes": 119948,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "mheducation.com": {
   "nom": "McGraw Hill",
   "date": "2026-04-10",
   "comptes": 13500136,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "mckesson.com": {
   "nom": "McKesson",
   "date": "2026-08-21",
   "comptes": 6404340,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "mdpi.com": {
   "nom": "MDPI",
   "date": "2016-08-30",
   "comptes": 845012,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms"
   ]
  },
  "mechodownload.com": {
   "nom": "Mecho Download",
   "date": "2013-10-31",
   "comptes": 437928,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "medela.com": {
   "nom": "Medela",
   "date": "2026-09-07",
   "comptes": 423947,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "mediaworks.co.nz": {
   "nom": "MediaWorks",
   "date": "2023-03-15",
   "comptes": 162710,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "meetmindful.com": {
   "nom": "MeetMindful",
   "date": "2020-01-26",
   "comptes": 1422717,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "adresses IP",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "memechat.app": {
   "nom": "MemeChat",
   "date": "2022-06-01",
   "comptes": 4348570,
   "donnees": [
    "adresses email",
    "noms d'utilisateur"
   ]
  },
  "meoair.com": {
   "nom": "MEO",
   "date": "2020-12-24",
   "comptes": 8227,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "achats",
    "noms d'utilisateur"
   ]
  },
  "mgmresorts.com": {
   "nom": "MGM Resorts",
   "date": "2019-07-25",
   "comptes": 3081321,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "miljodata.se": {
   "nom": "Miljödata",
   "date": "2025-08-25",
   "comptes": 870108,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "pièces d'identité",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "mindjolt.com": {
   "nom": "Mindjolt",
   "date": "2019-03-18",
   "comptes": 28364826,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms"
   ]
  },
  "minecraftpeforum.net": {
   "nom": "Minecraft Pocket Edition Forum",
   "date": "2015-05-24",
   "comptes": 16034,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "minecraftworldmap.com": {
   "nom": "Minecraft World Map",
   "date": "2016-01-15",
   "comptes": 71081,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "minefield.fr": {
   "nom": "Minefield",
   "date": "2015-06-28",
   "comptes": 188343,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "minehut.com": {
   "nom": "Minehut",
   "date": "2019-05-17",
   "comptes": 396533,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "minted.com": {
   "nom": "Minted",
   "date": "2020-05-06",
   "comptes": 4418182,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "mmgfusion.com": {
   "nom": "MMG Fusion",
   "date": "2020-12-20",
   "comptes": 2660295,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "mobifriends.com": {
   "nom": "MobiFriends",
   "date": "2020-01-06",
   "comptes": 3512952,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "modaco.com": {
   "nom": "MoDaCo",
   "date": "2016-01-01",
   "comptes": 879703,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "modbsolutions.com": {
   "nom": "Modern Business Solutions",
   "date": "2016-10-08",
   "comptes": 58843488,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "adresses IP",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "moneybookers.com": {
   "nom": "Money Bookers",
   "date": "2009-01-01",
   "comptes": 4483605,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "moneycontrol.com": {
   "nom": "Moneycontrol",
   "date": "2017-09-07",
   "comptes": 762874,
   "donnees": [
    "adresses email",
    "genres",
    "localisations",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "moody.edu": {
   "nom": "Moody Bible Institute",
   "date": "2026-06-15",
   "comptes": 2303416,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "morele.net": {
   "nom": "Morele.net",
   "date": "2018-10-10",
   "comptes": 2467304,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "mortalonline.com": {
   "nom": "Mortal Online",
   "date": "2018-06-17",
   "comptes": 606637,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "movieforums.com": {
   "nom": "Movie Forums",
   "date": "2022-11-24",
   "comptes": 39914,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "movieboxpro.app": {
   "nom": "MovieBoxPro",
   "date": "2024-04-15",
   "comptes": 6009014,
   "donnees": [
    "adresses email",
    "noms d'utilisateur"
   ]
  },
  "mpgh.net": {
   "nom": "MPGH",
   "date": "2015-10-22",
   "comptes": 3122898,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "mrgreengaming.com": {
   "nom": "Mr. Green Gaming",
   "date": "2024-03-01",
   "comptes": 27123,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "localisations",
    "adresses IP",
    "noms d'utilisateur"
   ]
  },
  "mrexcel.com": {
   "nom": "MrExcel",
   "date": "2016-12-05",
   "comptes": 366140,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "msi.com": {
   "nom": "MSI",
   "date": "2024-07-07",
   "comptes": 249990,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "mspy.com": {
   "nom": "mSpy (2024)",
   "date": "2024-06-09",
   "comptes": 2394179,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms"
   ]
  },
  "muah.ai": {
   "nom": "Muah.AI",
   "date": "2024-09-17",
   "comptes": 1910261,
   "donnees": [
    "adresses email"
   ]
  },
  "multiplayer.it": {
   "nom": "Multiplayer.it",
   "date": "2018-09-01",
   "comptes": 503957,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "muslimdirectory.co.uk": {
   "nom": "Muslim Directory",
   "date": "2014-02-17",
   "comptes": 37784,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "muslimmatch.com": {
   "nom": "Muslim Match",
   "date": "2016-06-24",
   "comptes": 149830,
   "donnees": [
    "adresses email",
    "localisations",
    "adresses IP",
    "mots de passe",
    "messages privés",
    "noms d'utilisateur"
   ]
  },
  "mylovely.ai": {
   "nom": "My Lovely AI",
   "date": "2026-04-07",
   "comptes": 106271,
   "donnees": [
    "adresses email"
   ]
  },
  "myfha.net": {
   "nom": "MyFHA",
   "date": "2015-02-18",
   "comptes": 972629,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "adresses postales"
   ]
  },
  "myfitnesspal.com": {
   "nom": "MyFitnessPal",
   "date": "2018-02-01",
   "comptes": 143606147,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "myheritage.com": {
   "nom": "MyHeritage",
   "date": "2017-10-26",
   "comptes": 91991358,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "mypertamina.id": {
   "nom": "MyPertamina",
   "date": "2022-11-01",
   "comptes": 5970416,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "myrepospace.com": {
   "nom": "myRepoSpace",
   "date": "2015-07-06",
   "comptes": 252751,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "myspace.com": {
   "nom": "MySpace",
   "date": "2008-07-01",
   "comptes": 359420698,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "mytheresa.com": {
   "nom": "Mytheresa",
   "date": "2026-04-12",
   "comptes": 84108,
   "donnees": [
    "adresses email",
    "noms",
    "données de carte bancaire",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "myvidster.com": {
   "nom": "MyVidster (2025)",
   "date": "2025-10-24",
   "comptes": 3864364,
   "donnees": [
    "adresses email",
    "noms d'utilisateur"
   ]
  },
  "napsgear.org": {
   "nom": "NapsGear",
   "date": "2015-10-21",
   "comptes": 287071,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "naughtyamerica.com": {
   "nom": "Naughty America",
   "date": "2016-03-14",
   "comptes": 1398630,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "neimanmarcus.com": {
   "nom": "Neiman Marcus",
   "date": "2024-04-14",
   "comptes": 31152842,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "noms",
    "données de carte bancaire",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "neogen.com": {
   "nom": "Neogen",
   "date": "2026-08-29",
   "comptes": 435963,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "neopets.com": {
   "nom": "Neopets",
   "date": "2013-05-05",
   "comptes": 26892897,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "adresses IP",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "neteller.com": {
   "nom": "Neteller",
   "date": "2010-05-17",
   "comptes": 3619948,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "adresses IP",
    "noms",
    "numéros de téléphone",
    "adresses postales",
    "questions secrètes"
   ]
  },
  "netgalley.com": {
   "nom": "NetGalley",
   "date": "2020-12-21",
   "comptes": 1436435,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "netlog.com": {
   "nom": "Netlog",
   "date": "2012-11-01",
   "comptes": 49038354,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "netshoes.com.br": {
   "nom": "Netshoes",
   "date": "2017-12-07",
   "comptes": 499836,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "achats"
   ]
  },
  "nextgenupdate.com": {
   "nom": "NextGenUpdate",
   "date": "2014-04-22",
   "comptes": 1194597,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "nexusmods.com": {
   "nom": "Nexus Mods",
   "date": "2013-07-22",
   "comptes": 5915013,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "nihonomaru.net": {
   "nom": "Nihonomaru",
   "date": "2015-12-01",
   "comptes": 1697282,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "gonitro.com": {
   "nom": "Nitro",
   "date": "2020-09-28",
   "comptes": 77159696,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe"
   ]
  },
  "nius.de": {
   "nom": "NIUS",
   "date": "2025-07-13",
   "comptes": 6090,
   "donnees": [
    "comptes bancaires",
    "adresses email",
    "noms",
    "données de carte bancaire",
    "adresses postales",
    "achats"
   ]
  },
  "nival.com": {
   "nom": "Nival",
   "date": "2016-02-29",
   "comptes": 1535473,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "noms d'utilisateur"
   ]
  },
  "nonnudegirls.org": {
   "nom": "Non Nude Girls",
   "date": "2013-05-21",
   "comptes": 75383,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "nulled.ch": {
   "nom": "Nulled.ch",
   "date": "2020-05-20",
   "comptes": 43491,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "messages privés",
    "noms d'utilisateur"
   ]
  },
  "nulled.cr": {
   "nom": "Nulled.cr",
   "date": "2016-05-06",
   "comptes": 599080,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "messages privés",
    "noms d'utilisateur"
   ]
  },
  "nurserycam.co.uk": {
   "nom": "NurseryCam",
   "date": "2021-02-12",
   "comptes": 10585,
   "donnees": [
    "adresses email"
   ]
  },
  "nvidia.com": {
   "nom": "NVIDIA",
   "date": "2022-02-23",
   "comptes": 71335,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "odido.nl": {
   "nom": "Odido",
   "date": "2026-02-12",
   "comptes": 6077025,
   "donnees": [
    "comptes bancaires",
    "dates de naissance",
    "adresses email",
    "genres",
    "pièces d'identité",
    "noms",
    "numéros de passeport",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "ogusers.com": {
   "nom": "OGUsers (2022 breach)",
   "date": "2022-07-13",
   "comptes": 529020,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "omgpop.com": {
   "nom": "OMGPOP",
   "date": "2013-01-01",
   "comptes": 7071293,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "omnicuris.com": {
   "nom": "Omnicuris",
   "date": "2025-06-08",
   "comptes": 215298,
   "donnees": [
    "adresses email",
    "localisations",
    "noms",
    "numéros de téléphone"
   ]
  },
  "onlinetrade.ru": {
   "nom": "Online Trade (Онлайн Трейд)",
   "date": "2022-09-19",
   "comptes": 3805265,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "onrpg.com": {
   "nom": "OnRPG",
   "date": "2016-07-01",
   "comptes": 1047640,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "onverse.com": {
   "nom": "Onverse",
   "date": "2016-01-01",
   "comptes": 800157,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "opencsgo.com": {
   "nom": "Open CS:GO",
   "date": "2017-11-28",
   "comptes": 512311,
   "donnees": [
    "adresses email",
    "adresses IP",
    "numéros de téléphone",
    "adresses postales",
    "achats",
    "noms d'utilisateur"
   ]
  },
  "opensubtitles.org": {
   "nom": "Open Subtitles",
   "date": "2021-08-01",
   "comptes": 6783158,
   "donnees": [
    "adresses email",
    "localisations",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "orange.ro": {
   "nom": "Orange Romania",
   "date": "2025-02-24",
   "comptes": 556557,
   "donnees": [
    "adresses email",
    "données de carte bancaire",
    "numéros de téléphone"
   ]
  },
  "ordersnapp.com": {
   "nom": "OrderSnapp",
   "date": "2020-06-29",
   "comptes": 1304447,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "ordineavvocatiroma.it": {
   "nom": "Ordine Avvocati di Roma",
   "date": "2019-05-07",
   "comptes": 41960,
   "donnees": [
    "adresses email",
    "localisations",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "otelier.com": {
   "nom": "Otelier",
   "date": "2024-07-01",
   "comptes": 436855,
   "donnees": [
    "adresses email",
    "noms",
    "données de carte bancaire",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "ovh.com": {
   "nom": "OVH",
   "date": "2015-05-01",
   "comptes": 452899,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "ownedcore.com": {
   "nom": "OwnedCore",
   "date": "2013-08-01",
   "comptes": 880331,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "oxfam.org.au": {
   "nom": "Oxfam",
   "date": "2021-01-20",
   "comptes": 1834006,
   "donnees": [
    "comptes bancaires",
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "données de carte bancaire",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "ozhairandbeauty.com": {
   "nom": "Oz Hair and Beauty",
   "date": "2026-08-15",
   "comptes": 1988331,
   "donnees": [
    "adresses email",
    "localisations",
    "noms",
    "numéros de téléphone",
    "achats"
   ]
  },
  "paddypower.com": {
   "nom": "Paddy Power",
   "date": "2010-10-25",
   "comptes": 590954,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "noms",
    "numéros de téléphone",
    "adresses postales",
    "questions secrètes",
    "noms d'utilisateur"
   ]
  },
  "paidwork.com": {
   "nom": "Paidwork",
   "date": "2026-03-29",
   "comptes": 23272765,
   "donnees": [
    "comptes bancaires",
    "dates de naissance",
    "adresses email",
    "genres",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "pampling.com": {
   "nom": "Pampling",
   "date": "2020-01-04",
   "comptes": 383468,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "pandabuy.com": {
   "nom": "Pandabuy",
   "date": "2024-03-31",
   "comptes": 1348407,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "panerabread.com": {
   "nom": "Panera Bread",
   "date": "2026-01-07",
   "comptes": 5112502,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "paragoncheats.com": {
   "nom": "Paragon Cheats",
   "date": "2021-05-22",
   "comptes": 188089,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms d'utilisateur"
   ]
  },
  "parkmobile.io": {
   "nom": "ParkMobile",
   "date": "2021-03-21",
   "comptes": 20949825,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "pass.sports.gouv.fr": {
   "nom": "Pass'Sport",
   "date": "2025-12-17",
   "comptes": 6366133,
   "donnees": [
    "adresses email",
    "genres",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "patreon.com": {
   "nom": "Patreon",
   "date": "2015-10-01",
   "comptes": 2330382,
   "donnees": [
    "adresses email",
    "mots de passe",
    "adresses postales",
    "messages privés"
   ]
  },
  "payasugym.com": {
   "nom": "PayAsUGym",
   "date": "2016-12-15",
   "comptes": 400260,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "données de carte bancaire",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "payhere.lk": {
   "nom": "PayHere",
   "date": "2022-03-27",
   "comptes": 1580249,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "données de carte bancaire",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "pctattletale.com": {
   "nom": "pcTattletale",
   "date": "2024-05-25",
   "comptes": 138751,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "peatix.com": {
   "nom": "Peatix",
   "date": "2019-01-20",
   "comptes": 4227907,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe"
   ]
  },
  "peoplesenergy.co.uk": {
   "nom": "People's Energy",
   "date": "2020-12-16",
   "comptes": 358822,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "petflow.com": {
   "nom": "PetFlow",
   "date": "2017-12-09",
   "comptes": 990919,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "phoenixim.ddns.net": {
   "nom": "Phoenix",
   "date": "2021-06-05",
   "comptes": 74776,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "phonehouse.es": {
   "nom": "Phone House España",
   "date": "2021-04-08",
   "comptes": 5223350,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "phpfreaks.com": {
   "nom": "PHP Freaks",
   "date": "2015-10-27",
   "comptes": 173891,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "pi-hole.net": {
   "nom": "Pi-hole",
   "date": "2025-07-30",
   "comptes": 29926,
   "donnees": [
    "adresses email",
    "noms"
   ]
  },
  "pipingrock.com": {
   "nom": "Piping Rock",
   "date": "2024-04-24",
   "comptes": 2103100,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "pitneybowes.com": {
   "nom": "Pitney Bowes",
   "date": "2026-04-20",
   "comptes": 8243989,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "pixelfederation.com": {
   "nom": "Pixel Federation",
   "date": "2013-12-04",
   "comptes": 38108,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "pixlr.com": {
   "nom": "Pixlr",
   "date": "2020-10-07",
   "comptes": 1906808,
   "donnees": [
    "adresses email",
    "localisations",
    "noms",
    "mots de passe"
   ]
  },
  "pizap.com": {
   "nom": "piZap",
   "date": "2017-12-07",
   "comptes": 41817893,
   "donnees": [
    "adresses email",
    "genres",
    "localisations",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "planetcalypsoforum.com": {
   "nom": "Planet Calypso",
   "date": "2019-07-01",
   "comptes": 62261,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "planet-ice.co.uk": {
   "nom": "Planet Ice",
   "date": "2023-01-14",
   "comptes": 240488,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "playbook.vc": {
   "nom": "Playbook",
   "date": "2020-10-19",
   "comptes": 50538,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "playcybergames.com": {
   "nom": "PlayCyberGames",
   "date": "2023-08-09",
   "comptes": 3681753,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "plex.tv": {
   "nom": "Plex",
   "date": "2015-07-02",
   "comptes": 327314,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "pluto.tv": {
   "nom": "Pluto TV",
   "date": "2018-10-12",
   "comptes": 3225080,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "adresses IP",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "poincampus.com": {
   "nom": "PoinCampus",
   "date": "2024-11-14",
   "comptes": 89116,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "numéros de téléphone"
   ]
  },
  "pokebip.com": {
   "nom": "Pokébip",
   "date": "2015-07-28",
   "comptes": 657001,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "pokemoncreed.net": {
   "nom": "Pokémon Creed",
   "date": "2014-08-08",
   "comptes": 116465,
   "donnees": [
    "adresses email",
    "genres",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "pokemonnegro.com": {
   "nom": "Pokémon Negro",
   "date": "2016-10-01",
   "comptes": 830155,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe"
   ]
  },
  "policeone.com": {
   "nom": "PoliceOne",
   "date": "2014-07-01",
   "comptes": 709926,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "poshmark.com": {
   "nom": "Poshmark",
   "date": "2018-05-16",
   "comptes": 36395491,
   "donnees": [
    "adresses email",
    "genres",
    "localisations",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "powerbot.org": {
   "nom": "Powerbot",
   "date": "2014-09-01",
   "comptes": 503501,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "ppcgeeks.com": {
   "nom": "PPCGeeks",
   "date": "2016-08-19",
   "comptes": 492518,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "preen.me": {
   "nom": "Preen.Me",
   "date": "2020-05-25",
   "comptes": 236105,
   "donnees": [
    "adresses email",
    "noms",
    "noms d'utilisateur"
   ]
  },
  "proctoru.com": {
   "nom": "ProctorU",
   "date": "2020-06-26",
   "comptes": 444453,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "programmingforums.org": {
   "nom": "Programming Forums",
   "date": "2015-12-01",
   "comptes": 707432,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "promo.com": {
   "nom": "Promo",
   "date": "2020-06-22",
   "comptes": 14610585,
   "donnees": [
    "adresses email",
    "genres",
    "adresses IP",
    "noms",
    "mots de passe"
   ]
  },
  "promofarma.com": {
   "nom": "Promofarma",
   "date": "2019-08-03",
   "comptes": 1277761,
   "donnees": [
    "adresses email",
    "noms"
   ]
  },
  "proptiger.com": {
   "nom": "PropTiger",
   "date": "2018-01-30",
   "comptes": 2156921,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "adresses IP",
    "noms",
    "mots de passe"
   ]
  },
  "prosper.com": {
   "nom": "Prosper",
   "date": "2025-09-01",
   "comptes": 17605276,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "pièces d'identité",
    "adresses IP",
    "noms",
    "adresses postales"
   ]
  },
  "protemps.com.sg": {
   "nom": "Protemps",
   "date": "2021-10-04",
   "comptes": 49591,
   "donnees": [
    "adresses email",
    "genres",
    "noms",
    "numéros de passeport",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "provecho.bio": {
   "nom": "Provecho",
   "date": "2026-01-30",
   "comptes": 712904,
   "donnees": [
    "adresses email",
    "noms d'utilisateur"
   ]
  },
  "ps3hax.net": {
   "nom": "PS3Hax",
   "date": "2015-07-01",
   "comptes": 447410,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "pspiso.com": {
   "nom": "PSP ISO",
   "date": "2015-09-25",
   "comptes": 1274070,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "psx-scene.com": {
   "nom": "PSX-Scene",
   "date": "2015-02-01",
   "comptes": 341118,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "bvdinfo.com": {
   "nom": "Public Business Data",
   "date": "2021-08-19",
   "comptes": 27917714,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "qnb.com": {
   "nom": "Qatar National Bank",
   "date": "2015-07-01",
   "comptes": 88678,
   "donnees": [
    "comptes bancaires",
    "dates de naissance",
    "genres",
    "localisations",
    "pièces d'identité",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "questions secrètes"
   ]
  },
  "qip.ru": {
   "nom": "QIP",
   "date": "2011-06-01",
   "comptes": 26183992,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "qraved.com": {
   "nom": "Qraved",
   "date": "2021-07-09",
   "comptes": 984519,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "quantumbooter.net": {
   "nom": "Quantum Booter",
   "date": "2014-03-18",
   "comptes": 48592,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "messages privés",
    "noms d'utilisateur"
   ]
  },
  "questel.com": {
   "nom": "Questel",
   "date": "2026-08-01",
   "comptes": 1226209,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "questionpro.com": {
   "nom": "QuestionPro",
   "date": "2022-05-21",
   "comptes": 22229637,
   "donnees": [
    "adresses email",
    "adresses IP"
   ]
  },
  "quidd.co": {
   "nom": "Quidd",
   "date": "2019-07-01",
   "comptes": 3805863,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "quinstreet.com": {
   "nom": "QuinStreet",
   "date": "2015-12-14",
   "comptes": 4907802,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "quitbro.app": {
   "nom": "Quitbro",
   "date": "2026-02-17",
   "comptes": 22874,
   "donnees": [
    "adresses email",
    "noms d'utilisateur"
   ]
  },
  "r2games.com": {
   "nom": "R2 (2017 forum breach)",
   "date": "2017-01-01",
   "comptes": 1023466,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "raaga.com": {
   "nom": "Raaga",
   "date": "2025-12-15",
   "comptes": 10225145,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "noms",
    "mots de passe"
   ]
  },
  "raidforums.com": {
   "nom": "RaidForums",
   "date": "2020-09-24",
   "comptes": 478604,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "railyatri.in": {
   "nom": "RailYatri",
   "date": "2022-12-26",
   "comptes": 23209732,
   "donnees": [
    "adresses email",
    "genres",
    "noms",
    "numéros de téléphone",
    "achats"
   ]
  },
  "ralphlauren.com": {
   "nom": "Ralph Lauren",
   "date": "2026-06-11",
   "comptes": 139903,
   "donnees": [
    "adresses email",
    "genres",
    "noms",
    "numéros de téléphone"
   ]
  },
  "rambler.ru": {
   "nom": "Rambler",
   "date": "2014-03-01",
   "comptes": 91436280,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "raychat.ir": {
   "nom": "Raychat",
   "date": "2021-01-31",
   "comptes": 938981,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe"
   ]
  },
  "rbx.rocks": {
   "nom": "Rbx.Rocks",
   "date": "2018-08-06",
   "comptes": 149958,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe"
   ]
  },
  "realestatemogul.com": {
   "nom": "Real Estate Mogul",
   "date": "2016-09-06",
   "comptes": 307768,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "realdudesinc.com": {
   "nom": "RealDudesInc",
   "date": "2022-10-22",
   "comptes": 101543,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "reborngaming.net": {
   "nom": "Reborn Gaming",
   "date": "2026-04-30",
   "comptes": 126,
   "donnees": [
    "adresses email",
    "adresses IP"
   ]
  },
  "reddoorz.com": {
   "nom": "RedDoorz",
   "date": "2020-09-04",
   "comptes": 5890277,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "bluesnap.com": {
   "nom": "Regpack",
   "date": "2016-05-20",
   "comptes": 104977,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "données de carte bancaire",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "reincubate.com": {
   "nom": "Reincubate",
   "date": "2017-05-11",
   "comptes": 616146,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe"
   ]
  },
  "rentomojo.com": {
   "nom": "RentoMojo",
   "date": "2023-04-15",
   "comptes": 2185697,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "pièces d'identité",
    "noms",
    "numéros de passeport",
    "mots de passe",
    "numéros de téléphone",
    "achats"
   ]
  },
  "texasgop.org": {
   "nom": "Republican Party of Texas",
   "date": "2021-09-11",
   "comptes": 72596,
   "donnees": [
    "adresses email",
    "localisations",
    "adresses IP",
    "noms"
   ]
  },
  "retinax.com": {
   "nom": "Retina-X",
   "date": "2017-02-23",
   "comptes": 71153,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "reverbnation.com": {
   "nom": "ReverbNation",
   "date": "2014-01-01",
   "comptes": 7040725,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "rightdev.co.uk": {
   "nom": "Rightbiz",
   "date": "2023-07-09",
   "comptes": 65376,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "ringcentral.com": {
   "nom": "RingCentral",
   "date": "2026-07-27",
   "comptes": 1596490,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "robinhood.com": {
   "nom": "Robinhood",
   "date": "2021-11-03",
   "comptes": 5003937,
   "donnees": [
    "adresses email"
   ]
  },
  "robinsonsmalls.com": {
   "nom": "Robinsons Malls",
   "date": "2024-06-01",
   "comptes": 195597,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "noms",
    "numéros de téléphone"
   ]
  },
  "roblox.com": {
   "nom": "Roblox",
   "date": "2016-07-31",
   "comptes": 52458,
   "donnees": [
    "adresses email",
    "adresses IP",
    "achats",
    "noms d'utilisateur"
   ]
  },
  "rdcglobal.com": {
   "nom": "Roblox Developer Conference (2023)",
   "date": "2020-12-18",
   "comptes": 3943,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "noms",
    "numéros de téléphone",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "roll20.net": {
   "nom": "Roll20",
   "date": "2018-12-26",
   "comptes": 3994436,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "données de carte bancaire",
    "mots de passe"
   ]
  },
  "romwe.com": {
   "nom": "Romwe",
   "date": "2018-06-01",
   "comptes": 19531820,
   "donnees": [
    "localisations",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "rosebuttboard.com": {
   "nom": "Rosebutt Board",
   "date": "2016-05-09",
   "comptes": 107303,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "royalenfield.com": {
   "nom": "Royal Enfield",
   "date": "2019-01-01",
   "comptes": 420873,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "rsboards.com": {
   "nom": "RuneScape Boards",
   "date": "2011-12-26",
   "comptes": 222762,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "russianamerica.com": {
   "nom": "Russian America",
   "date": "2017-01-01",
   "comptes": 182717,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "samsung.de": {
   "nom": "Samsung Germany Customer Tickets",
   "date": "2025-03-30",
   "comptes": 216333,
   "donnees": [
    "adresses email",
    "noms",
    "adresses postales",
    "achats"
   ]
  },
  "scentbird.com": {
   "nom": "Scentbird",
   "date": "2020-06-22",
   "comptes": 5814988,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "mots de passe"
   ]
  },
  "schenkyou.de": {
   "nom": "schenkYOU",
   "date": "2024-08-15",
   "comptes": 237349,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "mots de passe"
   ]
  },
  "scholastic.com": {
   "nom": "Scholastic",
   "date": "2025-01-08",
   "comptes": 4247768,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "sd42.ca": {
   "nom": "School District 42",
   "date": "2023-01-15",
   "comptes": 18850,
   "donnees": [
    "adresses email",
    "noms"
   ]
  },
  "scufgaming.com": {
   "nom": "Scuf Gaming",
   "date": "2015-06-05",
   "comptes": 128683,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "seedpeer.eu": {
   "nom": "Seedpeer",
   "date": "2015-07-12",
   "comptes": 281924,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "seniordating.app": {
   "nom": "Senior Dating",
   "date": "2024-11-23",
   "comptes": 765517,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations"
   ]
  },
  "sephora.com.au": {
   "nom": "Sephora",
   "date": "2017-01-09",
   "comptes": 780073,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms"
   ]
  },
  "serverpact.com": {
   "nom": "ServerPact",
   "date": "2016-01-01",
   "comptes": 73587,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "sevenrooms.com": {
   "nom": "SevenRooms",
   "date": "2022-12-11",
   "comptes": 1205385,
   "donnees": [
    "adresses email",
    "noms",
    "achats"
   ]
  },
  "shadi.com": {
   "nom": "Shadi.com",
   "date": "2016-07-09",
   "comptes": 2021984,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "shadow.tech": {
   "nom": "Shadow",
   "date": "2023-09-28",
   "comptes": 543295,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "adresses postales"
   ]
  },
  "sharecare.com": {
   "nom": "Sharecare",
   "date": "2026-08-12",
   "comptes": 318185,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "pièces d'identité",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "sharethis.com": {
   "nom": "ShareThis",
   "date": "2018-07-09",
   "comptes": 40960499,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "mots de passe"
   ]
  },
  "shein.com": {
   "nom": "SHEIN",
   "date": "2018-06-01",
   "comptes": 39086762,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "shitexpress.com": {
   "nom": "Shitexpress",
   "date": "2022-08-08",
   "comptes": 23817,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "adresses postales",
    "messages privés",
    "achats"
   ]
  },
  "shockgore.com": {
   "nom": "ShockGore",
   "date": "2020-08-11",
   "comptes": 73944,
   "donnees": [
    "adresses email",
    "genres",
    "adresses IP",
    "mots de passe",
    "messages privés",
    "noms d'utilisateur"
   ]
  },
  "shoezone.com": {
   "nom": "Shoe Zone",
   "date": "2024-06-28",
   "comptes": 46140,
   "donnees": [
    "adresses email",
    "noms",
    "données de carte bancaire",
    "adresses postales",
    "achats"
   ]
  },
  "shopback.com": {
   "nom": "ShopBack",
   "date": "2020-09-17",
   "comptes": 20529819,
   "donnees": [
    "adresses email",
    "localisations",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "shopperplus.ca": {
   "nom": "Shopper+",
   "date": "2020-09-14",
   "comptes": 878290,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "short-edition.com": {
   "nom": "Short Édition",
   "date": "2021-06-26",
   "comptes": 505466,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "shotbow.net": {
   "nom": "Shotbow",
   "date": "2016-05-09",
   "comptes": 1052753,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "sirhurt.net": {
   "nom": "SirHurt",
   "date": "2021-04-23",
   "comptes": 90655,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "sitepoint.com": {
   "nom": "SitePoint",
   "date": "2020-06-20",
   "comptes": 1021790,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "sktorrent.eu": {
   "nom": "SkTorrent",
   "date": "2016-02-19",
   "comptes": 117070,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "slickwraps.com": {
   "nom": "Slickwraps",
   "date": "2020-02-16",
   "comptes": 857611,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "slideteam.net": {
   "nom": "SlideTeam",
   "date": "2021-04-06",
   "comptes": 1464271,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe"
   ]
  },
  "smogon.com": {
   "nom": "Smogon",
   "date": "2017-09-10",
   "comptes": 386489,
   "donnees": [
    "adresses email",
    "genres",
    "localisations",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "snail.com": {
   "nom": "Snail",
   "date": "2015-03-14",
   "comptes": 1410899,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "snapchat.com": {
   "nom": "Snapchat",
   "date": "2014-01-01",
   "comptes": 4609615,
   "donnees": [
    "localisations",
    "numéros de téléphone",
    "noms d'utilisateur"
   ]
  },
  "soargames.com": {
   "nom": "SoarGames",
   "date": "2019-12-16",
   "comptes": 4774445,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "socialengineered.net": {
   "nom": "Social Engineered",
   "date": "2019-06-13",
   "comptes": 89392,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "messages privés",
    "noms d'utilisateur"
   ]
  },
  "siae.it": {
   "nom": "Società Italiana degli Autori ed Editori",
   "date": "2018-11-03",
   "comptes": 14609,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "songtrivia2.io": {
   "nom": "SongTrivia2",
   "date": "2026-04-02",
   "comptes": 291739,
   "donnees": [
    "jetons d'accès",
    "adresses email",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "sonicbids.com": {
   "nom": "Sonicbids",
   "date": "2019-12-30",
   "comptes": 751700,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "sony.com": {
   "nom": "Sony",
   "date": "2011-06-02",
   "comptes": 37103,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "soundradix.com": {
   "nom": "Sound Radix",
   "date": "2026-03-25",
   "comptes": 292993,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe"
   ]
  },
  "soundcloud.com": {
   "nom": "SoundCloud",
   "date": "2025-12-15",
   "comptes": 29815722,
   "donnees": [
    "adresses email",
    "localisations",
    "noms",
    "noms d'utilisateur"
   ]
  },
  "soundwave.com": {
   "nom": "Soundwave",
   "date": "2015-07-16",
   "comptes": 130705,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "noms",
    "mots de passe"
   ]
  },
  "sphero.com": {
   "nom": "Sphero",
   "date": "2023-09-09",
   "comptes": 832255,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "localisations",
    "noms",
    "noms d'utilisateur"
   ]
  },
  "spirol.com": {
   "nom": "Spirol",
   "date": "2014-02-22",
   "comptes": 55622,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "splitvpn.io": {
   "nom": "SplitVPN",
   "date": "2026-07-21",
   "comptes": 865336,
   "donnees": [
    "adresses email",
    "localisations",
    "adresses IP",
    "données de carte bancaire"
   ]
  },
  "sport2000.fr": {
   "nom": "Sport 2000",
   "date": "2024-04-18",
   "comptes": 3189643,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "spoutible.com": {
   "nom": "Spoutible",
   "date": "2024-01-31",
   "comptes": 207114,
   "donnees": [
    "adresses email",
    "genres",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "noms d'utilisateur"
   ]
  },
  "spyfone.com": {
   "nom": "SpyFone",
   "date": "2018-08-16",
   "comptes": 44109,
   "donnees": [
    "adresses email",
    "localisations",
    "adresses IP",
    "noms",
    "mots de passe"
   ]
  },
  "spyic.com": {
   "nom": "Spyic",
   "date": "2025-02-14",
   "comptes": 875999,
   "donnees": [
    "adresses email"
   ]
  },
  "spytech-web.com": {
   "nom": "Spytech",
   "date": "2024-06-04",
   "comptes": 5645,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "achats",
    "noms d'utilisateur"
   ]
  },
  "spyx.com": {
   "nom": "SpyX",
   "date": "2024-06-24",
   "comptes": 1977011,
   "donnees": [
    "adresses email",
    "localisations",
    "adresses IP",
    "mots de passe"
   ]
  },
  "spyzie.io": {
   "nom": "Spyzie",
   "date": "2024-02-22",
   "comptes": 518643,
   "donnees": [
    "adresses email"
   ]
  },
  "stalker.so": {
   "nom": "Stalker Online",
   "date": "2020-05-05",
   "comptes": 1385472,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "staminus.net": {
   "nom": "Staminus",
   "date": "2016-03-11",
   "comptes": 26815,
   "donnees": [
    "cartes bancaires",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "starnet.md": {
   "nom": "StarNet",
   "date": "2015-02-26",
   "comptes": 139395,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "adresses IP",
    "noms",
    "numéros de passeport",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "start.film": {
   "nom": "START",
   "date": "2021-06-01",
   "comptes": 7455386,
   "donnees": [
    "adresses email",
    "localisations",
    "noms",
    "mots de passe"
   ]
  },
  "startribune.com": {
   "nom": "StarTribune",
   "date": "2019-10-10",
   "comptes": 2192857,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "mots de passe",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "sterkinekor.co.za": {
   "nom": "Ster-Kinekor",
   "date": "2017-03-09",
   "comptes": 1619544,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "stockx.com": {
   "nom": "StockX",
   "date": "2019-07-26",
   "comptes": 6840339,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "adresses postales",
    "achats",
    "noms d'utilisateur"
   ]
  },
  "storenvy.com": {
   "nom": "Storenvy",
   "date": "2019-04-04",
   "comptes": 11052071,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "storybird.com": {
   "nom": "StoryBird",
   "date": "2015-08-07",
   "comptes": 1047200,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "straffic.io": {
   "nom": "Straffic",
   "date": "2020-02-14",
   "comptes": 48580249,
   "donnees": [
    "adresses email",
    "genres",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "stratfor.com": {
   "nom": "Stratfor",
   "date": "2011-12-24",
   "comptes": 859777,
   "donnees": [
    "cartes bancaires",
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "streamcraft.net": {
   "nom": "StreamCraft",
   "date": "2020-07-06",
   "comptes": 1772620,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "streeteasy.com": {
   "nom": "StreetEasy",
   "date": "2016-06-28",
   "comptes": 988230,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "stripchat.com": {
   "nom": "Stripchat",
   "date": "2021-11-05",
   "comptes": 10001355,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms d'utilisateur"
   ]
  },
  "strongholdkingdoms.com": {
   "nom": "Stronghold Kingdoms",
   "date": "2018-07-04",
   "comptes": 5187305,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "subagames.com": {
   "nom": "SubaGames",
   "date": "2016-11-01",
   "comptes": 6137666,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "substack.com": {
   "nom": "Substack",
   "date": "2025-10-23",
   "comptes": 663121,
   "donnees": [
    "adresses email",
    "numéros de téléphone"
   ]
  },
  "success.com": {
   "nom": "SUCCESS",
   "date": "2026-03-04",
   "comptes": 253510,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "sumotorrent.sx": {
   "nom": "Sumo Torrent",
   "date": "2014-06-21",
   "comptes": 285191,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "sundryfiles.com": {
   "nom": "Sundry Files",
   "date": "2022-01-21",
   "comptes": 274461,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "suno.com": {
   "nom": "Suno",
   "date": "2025-11-25",
   "comptes": 55282226,
   "donnees": [
    "adresses email",
    "noms",
    "données de carte bancaire",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "superdraft.io": {
   "nom": "SuperDraft",
   "date": "2024-10-27",
   "comptes": 300187,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "localisations",
    "mots de passe",
    "achats",
    "noms d'utilisateur"
   ]
  },
  "surveylama.com": {
   "nom": "SurveyLama",
   "date": "2024-02-01",
   "comptes": 4426879,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "svenskamagic.com": {
   "nom": "SvenskaMagic",
   "date": "2015-07-01",
   "comptes": 30327,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "sweclockers.com": {
   "nom": "SweClockers.com",
   "date": "2015-04-01",
   "comptes": 254867,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "switchit.hu": {
   "nom": "Switch",
   "date": "2024-10-01",
   "comptes": 5397,
   "donnees": [
    "adresses email",
    "noms"
   ]
  },
  "swordfantasy.com": {
   "nom": "SwordFantasy",
   "date": "2017-01-20",
   "comptes": 2690657,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "swvl.com": {
   "nom": "Swvl",
   "date": "2020-06-23",
   "comptes": 4195918,
   "donnees": [
    "adresses email",
    "noms",
    "données de carte bancaire",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "sysco.com": {
   "nom": "Sysco",
   "date": "2026-06-15",
   "comptes": 2691852,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "t2tea.com": {
   "nom": "T2",
   "date": "2024-04-17",
   "comptes": 94584,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "tailieu.vn": {
   "nom": "TaiLieu",
   "date": "2019-11-24",
   "comptes": 7327477,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "noms d'utilisateur"
   ]
  },
  "tamodo.com": {
   "nom": "Tamodo",
   "date": "2020-02-28",
   "comptes": 494945,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "adresses IP",
    "noms",
    "mots de passe"
   ]
  },
  "tangerinetelecom.com.au": {
   "nom": "Tangerine",
   "date": "2024-02-18",
   "comptes": 243462,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "flytap.com": {
   "nom": "TAP Air Portugal",
   "date": "2022-08-25",
   "comptes": 6083479,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "tappware.com": {
   "nom": "Tappware",
   "date": "2024-04-23",
   "comptes": 94734,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "pièces d'identité",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "taringa.net": {
   "nom": "Taringa",
   "date": "2017-08-01",
   "comptes": 27971100,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "solomid.net": {
   "nom": "Team SoloMid",
   "date": "2014-12-22",
   "comptes": 442166,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "technicpack.net": {
   "nom": "Technic",
   "date": "2018-11-30",
   "comptes": 265410,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "messages privés"
   ]
  },
  "teespring.com": {
   "nom": "Teespring",
   "date": "2020-04-01",
   "comptes": 8234193,
   "donnees": [
    "adresses email",
    "localisations",
    "noms"
   ]
  },
  "tehetsegkapu.hu": {
   "nom": "TehetségKapu",
   "date": "2025-03-26",
   "comptes": 54357,
   "donnees": [
    "adresses email",
    "noms",
    "noms d'utilisateur"
   ]
  },
  "trai.gov.in": {
   "nom": "Telecom Regulatory Authority of India",
   "date": "2015-04-27",
   "comptes": 107776,
   "donnees": [
    "adresses email"
   ]
  },
  "teracod.org": {
   "nom": "Teracod",
   "date": "2016-05-28",
   "comptes": 97151,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "messages privés",
    "noms d'utilisateur"
   ]
  },
  "terravision.eu": {
   "nom": "Terravision",
   "date": "2023-02-01",
   "comptes": 2075625,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "localisations",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "tesco.com": {
   "nom": "Tesco",
   "date": "2014-02-12",
   "comptes": 2239,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "thebotnet.com": {
   "nom": "The Botting Network",
   "date": "2012-08-12",
   "comptes": 96320,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "thecandidboard.com": {
   "nom": "The Candid Board",
   "date": "2015-09-03",
   "comptes": 178201,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "localisations",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "thecpexperience.com": {
   "nom": "The Club Penguin Experience",
   "date": "2024-10-14",
   "comptes": 6342,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "thefappening.so": {
   "nom": "The Fappening",
   "date": "2015-12-01",
   "comptes": 179030,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "theflyonthewall.com": {
   "nom": "The Fly on the Wall",
   "date": "2017-12-31",
   "comptes": 84011,
   "donnees": [
    "cartes bancaires",
    "adresses email",
    "genres",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "achats",
    "noms d'utilisateur"
   ]
  },
  "thehalloweenspot.com": {
   "nom": "The Halloween Spot",
   "date": "2019-09-27",
   "comptes": 10653,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "heritage.org": {
   "nom": "The Heritage Foundation",
   "date": "2024-07-09",
   "comptes": 72004,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "kodi.tv": {
   "nom": "The Kodi Foundation",
   "date": "2023-02-16",
   "comptes": 400635,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "messages privés",
    "noms d'utilisateur"
   ]
  },
  "thepostmillennial.com": {
   "nom": "The Post Millennial",
   "date": "2024-05-02",
   "comptes": 56973345,
   "donnees": [
    "adresses email",
    "genres",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "therealworld.net": {
   "nom": "The Real World",
   "date": "2024-11-15",
   "comptes": 324382,
   "donnees": [
    "adresses email",
    "noms d'utilisateur"
   ]
  },
  "thegradcafe.com": {
   "nom": "TheGradCafe",
   "date": "2023-02-26",
   "comptes": 310975,
   "donnees": [
    "adresses email",
    "genres",
    "localisations",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "rezeptwelt.de": {
   "nom": "Thermomix Recipe World Forum",
   "date": "2025-01-30",
   "comptes": 3123439,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "thesqua.re": {
   "nom": "TheSqua.re",
   "date": "2025-06-27",
   "comptes": 107041,
   "donnees": [
    "adresses email",
    "localisations",
    "noms",
    "numéros de téléphone"
   ]
  },
  "thetvdb.com": {
   "nom": "TheTVDB.com",
   "date": "2017-11-21",
   "comptes": 181871,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "thingiverse.com": {
   "nom": "Thingiverse",
   "date": "2020-10-13",
   "comptes": 228102,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "thishabboforum.com": {
   "nom": "ThisHabbo Forum",
   "date": "2014-01-01",
   "comptes": 612414,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "tianya.cn": {
   "nom": "Tianya",
   "date": "2011-12-26",
   "comptes": 29020808,
   "donnees": [
    "adresses email",
    "noms",
    "noms d'utilisateur"
   ]
  },
  "tibber.com": {
   "nom": "Tibber",
   "date": "2024-11-10",
   "comptes": 50002,
   "donnees": [
    "adresses email",
    "localisations",
    "noms",
    "achats"
   ]
  },
  "ticketcounter.nl": {
   "nom": "Ticketcounter",
   "date": "2021-02-22",
   "comptes": 1921722,
   "donnees": [
    "comptes bancaires",
    "dates de naissance",
    "adresses email",
    "genres",
    "adresses IP",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "ticketfly.com": {
   "nom": "Ticketfly",
   "date": "2018-05-31",
   "comptes": 26151608,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "tigo.chat": {
   "nom": "Tigo",
   "date": "2023-03-31",
   "comptes": 700394,
   "donnees": [
    "adresses email",
    "genres",
    "localisations",
    "adresses IP",
    "noms",
    "messages privés",
    "noms d'utilisateur"
   ]
  },
  "tiszavilag.hu": {
   "nom": "TISZA Világ",
   "date": "2025-10-06",
   "comptes": 198520,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "tnaflix.com": {
   "nom": "TNAFlix",
   "date": "2022-06-01",
   "comptes": 1374344,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "tokopedia.com": {
   "nom": "Tokopedia",
   "date": "2020-04-17",
   "comptes": 71443698,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "mots de passe"
   ]
  },
  "toondoo.com": {
   "nom": "ToonDoo",
   "date": "2019-08-21",
   "comptes": 6002694,
   "donnees": [
    "adresses email",
    "genres",
    "localisations",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "torrent-invites.com": {
   "nom": "Torrent Invites",
   "date": "2013-12-12",
   "comptes": 352120,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "toumei.co.jp": {
   "nom": "Toumei",
   "date": "2023-10-18",
   "comptes": 76682,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "tout.com": {
   "nom": "Tout",
   "date": "2014-09-11",
   "comptes": 652683,
   "donnees": [
    "adresses email",
    "localisations",
    "adresses IP",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "toybattles.net": {
   "nom": "Toy Battles",
   "date": "2026-02-06",
   "comptes": 1017,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms d'utilisateur"
   ]
  },
  "tracki.com": {
   "nom": "Tracki",
   "date": "2024-08-15",
   "comptes": 372557,
   "donnees": [
    "adresses email",
    "noms"
   ]
  },
  "traderie.com": {
   "nom": "Traderie",
   "date": "2022-09-24",
   "comptes": 364898,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms d'utilisateur"
   ]
  },
  "travelok.com": {
   "nom": "Travel Oklahoma",
   "date": "2020-12-17",
   "comptes": 637279,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "adresses postales"
   ]
  },
  "travelio.com": {
   "nom": "Travelio",
   "date": "2021-11-23",
   "comptes": 471376,
   "donnees": [
    "jetons d'accès",
    "dates de naissance",
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "trello.com": {
   "nom": "Trello",
   "date": "2024-01-16",
   "comptes": 15111945,
   "donnees": [
    "adresses email",
    "noms",
    "noms d'utilisateur"
   ]
  },
  "trillian.im": {
   "nom": "Trillian",
   "date": "2015-12-27",
   "comptes": 3827238,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "troyhunt.com": {
   "nom": "Troy Hunt's Mailchimp List",
   "date": "2025-03-25",
   "comptes": 16627,
   "donnees": [
    "adresses email",
    "localisations",
    "adresses IP"
   ]
  },
  "truckersmp.com": {
   "nom": "TruckersMP",
   "date": "2016-02-25",
   "comptes": 83957,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "truefire.com": {
   "nom": "TrueFire",
   "date": "2020-02-21",
   "comptes": 599667,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "truthfinder.com": {
   "nom": "Truth Finder",
   "date": "2019-04-12",
   "comptes": 8159573,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "tumblr.com": {
   "nom": "tumblr",
   "date": "2013-02-28",
   "comptes": 65469298,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "tunedglobal.com": {
   "nom": "Tuned Global",
   "date": "2016-03-16",
   "comptes": 985586,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "tunngle.net": {
   "nom": "Tunngle",
   "date": "2016-07-01",
   "comptes": 8192928,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "twitter.com": {
   "nom": "Twitter",
   "date": "2022-01-01",
   "comptes": 6682453,
   "donnees": [
    "adresses email",
    "localisations",
    "noms",
    "numéros de téléphone",
    "noms d'utilisateur"
   ]
  },
  "ualabee.com": {
   "nom": "Ualabee",
   "date": "2025-05-06",
   "comptes": 472296,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "numéros de téléphone"
   ]
  },
  "ubook.com": {
   "nom": "Ubook",
   "date": "2024-07-28",
   "comptes": 699908,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms"
   ]
  },
  "udemy.com": {
   "nom": "Udemy",
   "date": "2026-04-24",
   "comptes": 1401259,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "uiggy.com": {
   "nom": "Uiggy",
   "date": "2016-06-01",
   "comptes": 2682650,
   "donnees": [
    "adresses email",
    "genres",
    "noms"
   ]
  },
  "ulmon.com": {
   "nom": "Ulmon",
   "date": "2020-01-26",
   "comptes": 777769,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "intgovforum.org": {
   "nom": "UN Internet Governance Forum",
   "date": "2014-02-20",
   "comptes": 3200,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "underarmour.com": {
   "nom": "Under Armour",
   "date": "2025-11-17",
   "comptes": 72742892,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "noms",
    "achats"
   ]
  },
  "underworldempireforums.com": {
   "nom": "Underworld Empire",
   "date": "2017-04-25",
   "comptes": 428779,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "unicocampania.it": {
   "nom": "Unico Campania",
   "date": "2020-08-19",
   "comptes": 166031,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "unigame.me": {
   "nom": "Unigame",
   "date": "2019-12-14",
   "comptes": 843696,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "universarium.org": {
   "nom": "Universarium",
   "date": "2019-11-01",
   "comptes": 564962,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "universityofcalifornia.edu": {
   "nom": "University of California",
   "date": "2020-12-24",
   "comptes": 547422,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "nottingham.ac.uk": {
   "nom": "University of Nottingham",
   "date": "2026-06-09",
   "comptes": 454635,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "adresses IP",
    "noms",
    "numéros de passeport",
    "numéros de téléphone",
    "adresses postales",
    "achats",
    "noms d'utilisateur"
   ]
  },
  "upenn.edu": {
   "nom": "University of Pennsylvania",
   "date": "2025-10-30",
   "comptes": 623750,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "adresses postales"
   ]
  },
  "unrealengine.com": {
   "nom": "Unreal Engine",
   "date": "2016-08-11",
   "comptes": 530147,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "upstox.com": {
   "nom": "Upstox",
   "date": "2021-04-08",
   "comptes": 111002,
   "donnees": [
    "comptes bancaires",
    "dates de naissance",
    "adresses email",
    "genres",
    "pièces d'identité",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "utahgunexchange.com": {
   "nom": "Utah Gun Exchange",
   "date": "2020-07-17",
   "comptes": 235233,
   "donnees": [
    "adresses email",
    "genres",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "utair.ru": {
   "nom": "Utair",
   "date": "2019-03-21",
   "comptes": 401400,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "numéros de passeport",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "utorrent.com": {
   "nom": "uTorrent",
   "date": "2016-01-14",
   "comptes": 395044,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "vakinha.com.br": {
   "nom": "Vakinha",
   "date": "2020-06-22",
   "comptes": 4775203,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "vastaamo.fi": {
   "nom": "Vastaamo",
   "date": "2019-03-31",
   "comptes": 30433,
   "donnees": [
    "adresses email",
    "noms"
   ]
  },
  "vbulletin.com": {
   "nom": "vBulletin",
   "date": "2015-11-03",
   "comptes": 518966,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "questions secrètes"
   ]
  },
  "vedantu.com": {
   "nom": "Vedantu",
   "date": "2019-07-08",
   "comptes": 686899,
   "donnees": [
    "adresses email",
    "genres",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "verifications.io": {
   "nom": "Verifications.io",
   "date": "2019-02-25",
   "comptes": 763117241,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "adresses IP",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "verified.cm": {
   "nom": "Verified",
   "date": "2014-01-10",
   "comptes": 16919,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "messages privés",
    "noms d'utilisateur"
   ]
  },
  "v3rmillion.net": {
   "nom": "Vermillion",
   "date": "2014-08-30",
   "comptes": 8106,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "vianet.com.np": {
   "nom": "Vianet",
   "date": "2020-04-08",
   "comptes": 94353,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "victoryphones.com": {
   "nom": "Victory Phones",
   "date": "2017-01-01",
   "comptes": 166046,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "vietnamairlines.com": {
   "nom": "Vietnam Airlines",
   "date": "2025-06-20",
   "comptes": 7316915,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "numéros de téléphone"
   ]
  },
  "viewfines.co.za": {
   "nom": "ViewFines",
   "date": "2018-05-07",
   "comptes": 777649,
   "donnees": [
    "adresses email",
    "pièces d'identité",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "vimeo.com": {
   "nom": "Vimeo",
   "date": "2026-04-28",
   "comptes": 119167,
   "donnees": [
    "adresses email",
    "noms"
   ]
  },
  "vimeworld.com": {
   "nom": "VimeWorld",
   "date": "2018-10-01",
   "comptes": 3118964,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "vivaair.com": {
   "nom": "Viva Air",
   "date": "2022-03-14",
   "comptes": 932232,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "données de carte bancaire",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "vk.com": {
   "nom": "VK",
   "date": "2012-01-01",
   "comptes": 93338602,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "zing.vn": {
   "nom": "VNG",
   "date": "2015-05-19",
   "comptes": 24853850,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "vodafone.is": {
   "nom": "Vodafone",
   "date": "2013-11-30",
   "comptes": 56021,
   "donnees": [
    "cartes bancaires",
    "adresses email",
    "pièces d'identité",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "achats",
    "noms d'utilisateur"
   ]
  },
  "void.to": {
   "nom": "Void.to",
   "date": "2019-06-13",
   "comptes": 95431,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "messages privés",
    "noms d'utilisateur"
   ]
  },
  "vultr.com": {
   "nom": "Vultr",
   "date": "2022-07-08",
   "comptes": 187872,
   "donnees": [
    "adresses email",
    "localisations",
    "adresses IP",
    "noms"
   ]
  },
  "wakanim.tv": {
   "nom": "Wakanim",
   "date": "2022-08-28",
   "comptes": 6706951,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "wanelo.com": {
   "nom": "Wanelo",
   "date": "2018-12-13",
   "comptes": 23165793,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "adresses postales"
   ]
  },
  "thewarinc.com": {
   "nom": "War Inc.",
   "date": "2012-07-04",
   "comptes": 1020136,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "warframe.com": {
   "nom": "Warframe",
   "date": "2014-11-24",
   "comptes": 819478,
   "donnees": [
    "adresses email",
    "noms d'utilisateur"
   ]
  },
  "warmane.com": {
   "nom": "Warmane",
   "date": "2016-12-01",
   "comptes": 1116256,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "foodworkercard.wa.gov": {
   "nom": "Washington State Food Worker Card",
   "date": "2022-11-17",
   "comptes": 1594305,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "localisations",
    "noms"
   ]
  },
  "wattpad.com": {
   "nom": "Wattpad",
   "date": "2020-06-29",
   "comptes": 268765495,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "adresses IP",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "weheartit.com": {
   "nom": "We Heart It",
   "date": "2013-11-03",
   "comptes": 8600635,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "webhostingtalk.com": {
   "nom": "Web Hosting Talk",
   "date": "2016-07-01",
   "comptes": 515149,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "wedmegood.com": {
   "nom": "WedMeGood",
   "date": "2021-01-06",
   "comptes": 1306723,
   "donnees": [
    "adresses email",
    "genres",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "sayweee.com": {
   "nom": "Weee",
   "date": "2022-07-11",
   "comptes": 1117405,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "achats"
   ]
  },
  "weleakinfo.com": {
   "nom": "WeLeakInfo",
   "date": "2021-03-08",
   "comptes": 11788,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "données de carte bancaire",
    "adresses postales",
    "achats"
   ]
  },
  "welhof.com": {
   "nom": "Welhof",
   "date": "2023-12-01",
   "comptes": 107292,
   "donnees": [
    "adresses email",
    "noms",
    "adresses postales",
    "achats"
   ]
  },
  "wendys.com.ph": {
   "nom": "Wendy's",
   "date": "2018-03-31",
   "comptes": 52485,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "whitedate.net": {
   "nom": "WhiteDate",
   "date": "2025-12-29",
   "comptes": 20363,
   "donnees": [
    "adresses email",
    "genres",
    "localisations",
    "adresses IP",
    "mots de passe",
    "messages privés",
    "noms d'utilisateur"
   ]
  },
  "whitepages.com": {
   "nom": "Whitepages",
   "date": "2016-06-27",
   "comptes": 11657763,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe"
   ]
  },
  "whmcs.com": {
   "nom": "WHMCS",
   "date": "2012-05-21",
   "comptes": 134047,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "données de carte bancaire",
    "mots de passe",
    "adresses postales"
   ]
  },
  "wifelovers.com": {
   "nom": "Wife Lovers",
   "date": "2018-10-07",
   "comptes": 1274051,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "wiiuiso.com": {
   "nom": "WIIU ISO",
   "date": "2015-09-25",
   "comptes": 458155,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "wildstar-online.com": {
   "nom": "WildStar",
   "date": "2015-07-11",
   "comptes": 738556,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "win7vista.com": {
   "nom": "Win7Vista Forum",
   "date": "2013-09-03",
   "comptes": 202683,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "messages privés",
    "noms d'utilisateur"
   ]
  },
  "windows93.net": {
   "nom": "Windows93 / Myspace93",
   "date": "2021-01-01",
   "comptes": 46105,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "wired.com": {
   "nom": "WIRED",
   "date": "2025-09-08",
   "comptes": 2364431,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "wiredbucks.com": {
   "nom": "WiredBucks",
   "date": "2022-05-25",
   "comptes": 918529,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "wishbone.io": {
   "nom": "Wishbone (2020)",
   "date": "2020-01-27",
   "comptes": 9705172,
   "donnees": [
    "jetons d'accès",
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "noms d'utilisateur"
   ]
  },
  "wizishop.fr": {
   "nom": "WiziShop",
   "date": "2020-07-14",
   "comptes": 2856769,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "woflow.com": {
   "nom": "Woflow",
   "date": "2026-03-04",
   "comptes": 447593,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "wongnai.com": {
   "nom": "Wongnai",
   "date": "2020-10-28",
   "comptes": 3924454,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "localisations",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "wotlabs.net": {
   "nom": "WoTLabs",
   "date": "2024-03-03",
   "comptes": 21994,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "noms d'utilisateur"
   ]
  },
  "wpsandbox.io": {
   "nom": "WPSandbox",
   "date": "2018-11-04",
   "comptes": 858,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "wptapl.com": {
   "nom": "WPT Amateur Poker League",
   "date": "2014-01-04",
   "comptes": 148366,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "xat.com": {
   "nom": "xat",
   "date": "2015-11-04",
   "comptes": 5968783,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "xbox360iso.com": {
   "nom": "Xbox 360 ISO",
   "date": "2015-09-25",
   "comptes": 1296959,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "xboxscene.com": {
   "nom": "Xbox-Scene",
   "date": "2015-02-01",
   "comptes": 432552,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "xhamster.com": {
   "nom": "xHamster",
   "date": "2016-11-28",
   "comptes": 377377,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "xkcd.com": {
   "nom": "XKCD",
   "date": "2019-07-01",
   "comptes": 561991,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "xpgamesaves.com": {
   "nom": "XPG",
   "date": "2016-01-01",
   "comptes": 890341,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "xsplit.com": {
   "nom": "XSplit",
   "date": "2013-11-07",
   "comptes": 2983472,
   "donnees": [
    "adresses email",
    "noms",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "yahoo.com": {
   "nom": "Yahoo",
   "date": "2012-07-11",
   "comptes": 453427,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "yam.com": {
   "nom": "Yam",
   "date": "2013-06-02",
   "comptes": 13258797,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "yatra.com": {
   "nom": "Yatra",
   "date": "2013-09-01",
   "comptes": 5033997,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "yonema.com": {
   "nom": "Yonéma",
   "date": "2024-11-21",
   "comptes": 35962,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "yotepresto.com": {
   "nom": "yotepresto.com",
   "date": "2020-06-22",
   "comptes": 1444629,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "youku.com": {
   "nom": "Youku",
   "date": "2016-12-01",
   "comptes": 91890110,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "youngliving.com": {
   "nom": "Young Living Essential Oils",
   "date": "2024-12-11",
   "comptes": 1128951,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "localisations",
    "noms"
   ]
  },
  "younow.com": {
   "nom": "YouNow",
   "date": "2019-02-15",
   "comptes": 18241518,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "noms d'utilisateur"
   ]
  },
  "youporn.com": {
   "nom": "YouPorn",
   "date": "2012-02-21",
   "comptes": 1327567,
   "donnees": [
    "adresses email",
    "mots de passe"
   ]
  },
  "youthmanual.com": {
   "nom": "Youthmanual",
   "date": "2019-01-31",
   "comptes": 937912,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "zacks.com": {
   "nom": "Zacks (2024)",
   "date": "2024-06-22",
   "comptes": 11994223,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone",
    "adresses postales",
    "noms d'utilisateur"
   ]
  },
  "zadig-et-voltaire.com": {
   "nom": "Zadig & Voltaire",
   "date": "2023-11-16",
   "comptes": 586895,
   "donnees": [
    "adresses email",
    "genres",
    "noms",
    "numéros de téléphone",
    "adresses postales"
   ]
  },
  "zap-hosting.com": {
   "nom": "ZAP-Hosting",
   "date": "2021-11-22",
   "comptes": 746682,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "numéros de téléphone",
    "adresses postales",
    "achats"
   ]
  },
  "zara.com": {
   "nom": "Zara",
   "date": "2026-04-15",
   "comptes": 197376,
   "donnees": [
    "adresses email",
    "localisations",
    "achats"
   ]
  },
  "zenbusiness.com": {
   "nom": "ZenBusiness",
   "date": "2026-03-27",
   "comptes": 5118184,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone"
   ]
  },
  "zilvia.net": {
   "nom": "Zilvia.net",
   "date": "2025-11-06",
   "comptes": 287863,
   "donnees": [
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "z-lib.is": {
   "nom": "Z-lib",
   "date": "2024-06-20",
   "comptes": 9737374,
   "donnees": [
    "adresses email",
    "localisations",
    "mots de passe",
    "achats",
    "noms d'utilisateur"
   ]
  },
  "zomato.com": {
   "nom": "Zomato",
   "date": "2017-05-17",
   "comptes": 16472873,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "zoomcar.com": {
   "nom": "Zoomcar",
   "date": "2018-07-01",
   "comptes": 3589795,
   "donnees": [
    "adresses email",
    "adresses IP",
    "noms",
    "mots de passe",
    "numéros de téléphone"
   ]
  },
  "zoosk.com": {
   "nom": "Zoosk (2020)",
   "date": "2020-01-12",
   "comptes": 23927853,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "noms"
   ]
  },
  "zooville.org": {
   "nom": "Zooville",
   "date": "2019-09-27",
   "comptes": 71407,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "adresses IP",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "zurich.co.jp": {
   "nom": "Zurich",
   "date": "2023-01-08",
   "comptes": 756737,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "noms"
   ]
  },
  "zynga.com": {
   "nom": "Zynga",
   "date": "2019-09-01",
   "comptes": 172869660,
   "donnees": [
    "adresses email",
    "mots de passe",
    "numéros de téléphone",
    "noms d'utilisateur"
   ]
  },
  "gemotest.ru": {
   "nom": "Медицинская лаборатория Гемотест (Gemotest)",
   "date": "2022-04-22",
   "comptes": 6341495,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "pièces d'identité",
    "données de santé",
    "noms",
    "numéros de passeport",
    "adresses postales"
   ]
  },
  "parapa.mail.ru": {
   "nom": "Пара Па",
   "date": "2016-08-08",
   "comptes": 4946850,
   "donnees": [
    "adresses email",
    "mots de passe",
    "noms d'utilisateur"
   ]
  },
  "sprashivai.ru": {
   "nom": "Спрашивай.ру",
   "date": "2015-05-11",
   "comptes": 3474763,
   "donnees": [
    "dates de naissance",
    "adresses email",
    "genres",
    "localisations",
    "adresses IP",
    "mots de passe"
   ]
  },
  "ggumim.co.kr": {
   "nom": "집꾸미기",
   "date": "2020-03-27",
   "comptes": 1298651,
   "donnees": [
    "adresses email",
    "noms",
    "numéros de téléphone",
    "noms d'utilisateur"
   ]
  }
 }
}
